import { createDecorator } from '@tencent/containerized';
import 'core-js/modules/es.reflect.to-string-tag.js';
import 'core-js/modules/es.reflect.construct.js';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _get from '@babel/runtime/helpers/get';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.error.to-string.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.array.slice.js';
import 'core-js/modules/es.array.for-each.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/es.promise.js';
import { __spreadArray, __read, __generator, __values, __decorate, __metadata, __param, __awaiter } from 'tslib';
import { IDocMetaDomainService, IAuthDomainService, ICollaborateDomainService, ILikeDomainService, NOT_LOGIN_TINYID, IAccountDomainService, IMessageDomainService, ILogoutMessageType, ILoginDomainService, IEnterpriseAccountDomainService, FromDomin } from '@tencent/ark-domain';
export * from '@tencent/ark-domain';
import 'core-js/modules/es.object.define-property.js';
import 'core-js/modules/es.array.is-array.js';
import { trackDisposable, markTracked, Disposable } from '@tencent/dispose-tree';
import 'core-js/modules/es.symbol.iterator.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.symbol.js';
import 'core-js/modules/es.symbol.description.js';
import { ConnectionController, ServerMessageNoticeEventType } from '@tencent/docs-connection';
import { Logger } from '@tencent/logger';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.global-this.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/es.regexp.dot-all.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.regexp.sticky.js';
import { appConfigInstance } from '@tencent/ark-utils/lib/config';
import ua from '@tencent/docs-user-agent';
import 'core-js/modules/es.function.bind.js';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import 'core-js/modules/es.set.js';
import 'core-js/modules/web.timers.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/es.object.define-properties.js';
import 'reflect-metadata';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.parse-int.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.date.now.js';
import { UserInfo } from '@tencent/ark-model';
import { StorageManager, DBEngineType, UserInfoStorage } from '@tencent/ark-storage';
import 'core-js/modules/es.string.search.js';
import 'core-js/modules/es.string.match.js';
import 'core-js/modules/es.object.get-own-property-names.js';
import 'core-js/modules/es.object.get-own-property-descriptor.js';
import { network } from '@tencent/netcheck';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.array.some.js';
import MsgCenter from '@tencent/docs-scenario-components-message-center';
import 'core-js/modules/es.number.constructor.js';
import QRCode from '@tencent/docs-qrcode';
import 'core-js/modules/es.string.starts-with.js';
import 'core-js/modules/es.array.index-of.js';
import 'core-js/modules/es.string.replace.js';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'core-js/modules/web.btoa.js';
import 'core-js/modules/web.dom-exception.constructor.js';
import 'core-js/modules/web.dom-exception.stack.js';
import 'core-js/modules/web.dom-exception.to-string-tag.js';
import 'core-js/modules/es.array.find.js';
import 'core-js/modules/es.json.stringify.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.array.splice.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import { tencentDocOpenUrlForAll } from '@tencent/tencent_doc_open_url';
import 'core-js/modules/es.regexp.test.js';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { networkRequest } from '@tencent/ark-request';

var IConnectionControllerService = createDecorator('IConnectionControllerService');

var getLockKey = function getLockKey(propertyName) {
  return "".concat(String(propertyName), "__locked");
};
var getResultKey = function getResultKey(propertyName) {
  return "".concat(String(propertyName), "__result");
};
/**
 * method decorator 给 method 加锁，执行完一次后加锁
 */
function lockOnce() {
  return function (target, propertyKey, descriptor) {
    var originalValue = descriptor.value;
    var lockKey = getLockKey(propertyKey);
    var resultKey = getResultKey(propertyKey);
    descriptor.value = function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      if (!this[lockKey]) {
        this[resultKey] = originalValue.call.apply(originalValue, __spreadArray([this], __read(args), false));
        this[lockKey] = true;
      }
      return this[resultKey];
    };
  };
}
/**
 * method decorator，解除 lock 的限制使其可以继续执行
 * @param lockedMethodName 需要释放的key，指的是class中lock的方法名
 */
function releaseLock(lockedMethodName) {
  return function (target, propertyKey, descriptor) {
    var originalValue = descriptor.value;
    var lockKey = getLockKey(lockedMethodName);
    var resultKey = getResultKey(lockedMethodName);
    descriptor.value = function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      if (this[lockKey]) {
        this[lockKey] = false;
        this[resultKey] = undefined;
      }
      return originalValue.call.apply(originalValue, __spreadArray([this], __read(args), false));
    };
  };
}

var Node = /** @class */function () {
  function Node(element) {
    this.element = element;
    this.next = Node.Undefined;
    this.prev = Node.Undefined;
  }
  Node.Undefined = new Node(undefined);
  return Node;
}();
var LinkedList = /** @class */function () {
  function LinkedList() {
    this.first = Node.Undefined;
    this.last = Node.Undefined;
    this.mSize = 0;
  }
  Object.defineProperty(LinkedList.prototype, "size", {
    get: function get() {
      return this.mSize;
    },
    enumerable: false,
    configurable: true
  });
  LinkedList.prototype.isEmpty = function () {
    return this.first === Node.Undefined;
  };
  LinkedList.prototype.clear = function () {
    this.first = Node.Undefined;
    this.last = Node.Undefined;
    this.mSize = 0;
  };
  LinkedList.prototype.unshift = function (element) {
    return this.insert(element, false);
  };
  LinkedList.prototype.push = function (element) {
    return this.insert(element, true);
  };
  LinkedList.prototype.shift = function () {
    if (this.first === Node.Undefined) {
      return undefined;
    }
    var res = this.first.element;
    this.remove(this.first);
    return res;
  };
  LinkedList.prototype.pop = function () {
    if (this.last === Node.Undefined) {
      return undefined;
    }
    var res = this.last.element;
    this.remove(this.last);
    return res;
  };
  LinkedList.prototype[Symbol.iterator] = function () {
    var node;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          node = this.first;
          _a.label = 1;
        case 1:
          if (!(node !== Node.Undefined)) return [3 /*break*/, 3];
          return [4 /*yield*/, node.element];
        case 2:
          _a.sent();
          node = node.next;
          return [3 /*break*/, 1];
        case 3:
          return [2 /*return*/];
      }
    });
  };

  LinkedList.prototype.insert = function (element, atTheEnd) {
    var _this = this;
    var newNode = new Node(element);
    if (this.first === Node.Undefined) {
      this.first = newNode;
      this.last = newNode;
    } else if (atTheEnd) {
      // push
      var oldLast = this.last;
      this.last = newNode;
      newNode.prev = oldLast;
      oldLast.next = newNode;
    } else {
      // unshift
      var oldFirst = this.first;
      this.first = newNode;
      newNode.next = oldFirst;
      oldFirst.prev = newNode;
    }
    this.mSize += 1;
    var didRemove = false;
    return function () {
      if (!didRemove) {
        didRemove = true;
        _this.remove(newNode);
      }
    };
  };
  LinkedList.prototype.remove = function (node) {
    if (node.prev !== Node.Undefined && node.next !== Node.Undefined) {
      // middle
      var anchor = node.prev;
      anchor.next = node.next;
      node.next.prev = anchor;
      node.next = Node.Undefined;
      node.prev = Node.Undefined;
    } else if (node.prev === Node.Undefined && node.next === Node.Undefined) {
      // only node
      this.first = Node.Undefined;
      this.last = Node.Undefined;
    } else if (node.next === Node.Undefined) {
      // last
      this.last = this.last.prev;
      this.last.next = Node.Undefined;
      node.prev = Node.Undefined;
    } else if (node.prev === Node.Undefined) {
      // first
      this.first = this.first.next;
      this.first.prev = Node.Undefined;
      node.next = Node.Undefined;
    }
    // done
    this.mSize -= 1;
  };
  return LinkedList;
}();

var Emitter = /** @class */function () {
  function Emitter(options) {
    this.disposed = false;
    this.options = options;
  }
  Object.defineProperty(Emitter.prototype, "event", {
    /**
       * 可用于订阅该 Emitter 的事件
       */
    get: function get() {
      var _this = this;
      if (!this.mEvent) {
        this.mEvent = function (listener, thisArgs, disposables) {
          var _a, _b, _c;
          if (!_this.listeners) {
            _this.listeners = new LinkedList();
          }
          var firstListener = _this.listeners.isEmpty();
          if (firstListener && ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.onFirstListenerAdd)) {
            _this.options.onFirstListenerAdd(_this);
          }
          var remove = _this.listeners.push(!thisArgs ? listener : [listener, thisArgs]);
          if (firstListener && ((_b = _this.options) === null || _b === void 0 ? void 0 : _b.onFirstListenerDidAdd)) {
            _this.options.onFirstListenerDidAdd(_this);
          }
          if ((_c = _this.options) === null || _c === void 0 ? void 0 : _c.onListenerDidAdd) {
            _this.options.onListenerDidAdd(_this, listener, thisArgs);
          }
          var result = {
            dispose: function dispose() {
              var _a;
              if (!_this.disposed) {
                remove();
                if ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.onLastListenerRemove) {
                  var hasListeners = _this.listeners && !_this.listeners.isEmpty();
                  if (!hasListeners) {
                    _this.options.onLastListenerRemove(_this);
                  }
                }
              }
              markTracked(result);
            },
            disposableId: 'event'
          };
          if (Array.isArray(disposables)) {
            disposables.push(result);
          }
          trackDisposable(result);
          return result;
        };
      }
      return this.mEvent;
    },
    enumerable: false,
    configurable: true
  });
  /**
     * To be kept private to fire an event to
     * subscribers
     */
  Emitter.prototype.fire = function (event) {
    var e_1, _a;
    if (this.listeners) {
      // put all [listener,event]-pairs into delivery queue
      // then emit all event. an inner/nested event might be
      // the driver of this
      if (!this.deliveryQueue) {
        this.deliveryQueue = new LinkedList();
      }
      try {
        for (var _b = __values(this.listeners), _c = _b.next(); !_c.done; _c = _b.next()) {
          var listener = _c.value;
          this.deliveryQueue.push([listener, event]);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      while (this.deliveryQueue.size > 0) {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        var _d = __read(this.deliveryQueue.shift(), 2),
          listener = _d[0],
          event_1 = _d[1];
        try {
          if (typeof listener === 'function') {
            listener.call(undefined, event_1);
          } else {
            listener[0].call(listener[1], event_1);
          }
        } catch (e) {
          console.error(e);
        }
      }
    }
  };
  Emitter.prototype.dispose = function () {
    if (this.listeners) {
      this.listeners.clear();
    }
    if (this.deliveryQueue) {
      this.deliveryQueue.clear();
    }
    this.disposed = true;
  };
  return Emitter;
}();

/**
 * @description localstorage processing
 * @source  https://github.com/steamerjs/steamer-browserutils
 */
/**
 * 判断value的类型
 * javascript 1.8.5之后toString.call已经支持ok了。不需要再对null, undefined做特殊处理了
 * @param type     type的类型：  Null | Undefined | Array | Object etc
 * @param value
 * @returns
 */
function isType(type, value) {
  return Object.prototype.toString.call(value) === "[object ".concat(type, "]");
}
function isArray(value) {
  return isType('Array', value);
}
function isObject(value) {
  return isType('Object', value);
}

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** ConnectionControllerOptions 必要参数， 之前是传品类大写 这里先传成ARK */
var MODULE_TAG = 'ARK';
/** 用户主动关闭链接层 code 要加的在这里扩展*/
var SHUTDOWN_CODE;
(function (SHUTDOWN_CODE) {
  SHUTDOWN_CODE[SHUTDOWN_CODE["USER_INITIATIVE"] = 72105] = "USER_INITIATIVE";
})(SHUTDOWN_CODE || (SHUTDOWN_CODE = {}));
var ConnectionControllerService = /*#__PURE__*/function (_Disposable) {
  _inherits(ConnectionControllerService, _Disposable);
  var _super = _createSuper$3(ConnectionControllerService);
  function ConnectionControllerService(docMetaDomain, authDomain, collaborateDomain, likeDomain) {
    var _this;
    _classCallCheck(this, ConnectionControllerService);
    _this = _super.call(this);
    _this.docMetaDomain = docMetaDomain;
    _this.authDomain = authDomain;
    _this.collaborateDomain = collaborateDomain;
    _this.likeDomain = likeDomain;
    _this.onEnterOnlineEmitter = new Emitter();
    _this.onEnterOfflineEmitter = new Emitter();
    _this.onRoomStateChangeEmitter = new Emitter();
    _this.onNetReconnectedFailEmitter = new Emitter();
    _this.logger = new Logger('ConnectionControllerService').use('console');
    _this.onEnterOnline = _this.onEnterOnlineEmitter.event;
    _this.onEnterOffline = _this.onEnterOfflineEmitter.event;
    _this.onRoomStateChange = _this.onRoomStateChangeEmitter.event;
    _this.onNetReconnectedFail = _this.onNetReconnectedFailEmitter.event;
    _this.configEventHandlerMap();
    _this.configMsgHandlerMap();
    return _this;
  }
  _createClass(ConnectionControllerService, [{
    key: "openRoom",
    value: function openRoom() {
      if (!this.connectionController) {
        throw new Error('没有 connectionController 对象，需要先通过 initConnectionControllerWithClientVars 初始化');
      }
      this.connectionController.connect();
    }
  }, {
    key: "shutDown",
    value: function shutDown(closeReason) {
      if (!this.connectionController) {
        throw new Error('没有 connectionController 对象，需要先通过 initConnectionControllerWithClientVars 初始化');
      }
      var tempReason = Object.assign({}, closeReason);
      // 如果业务方没有传errCode，默认加一个
      if (!tempReason.errCode) {
        tempReason.errCode = 72105 /* SHUTDOWN_CODE.USER_INITIATIVE */;
      }

      this.connectionController.disconnect(tempReason);
    }
  }, {
    key: "setConnectionController",
    value: function setConnectionController(connectionController) {
      var _this2 = this;
      // 添加事件监听
      this.connectionController = connectionController;
      this.connectionController.onConnectionEvent(function (result) {
        _this2.dispathEvent(result);
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _a;
      _get(_getPrototypeOf(ConnectionControllerService.prototype), "dispose", this).call(this);
      (_a = this.connectionController) === null || _a === void 0 ? void 0 : _a.dispose();
      this.connectionController = null;
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return");
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "getConnectionController",
    value: function getConnectionController() {
      return this.connectionController;
    }
  }, {
    key: "initConnectionControllerWithClientVars",
    value: function initConnectionControllerWithClientVars(clientVars) {
      var _this3 = this;
      // 构建 options 结构
      var options = {
        serverVars: clientVars.collab_client_vars,
        uuId: clientVars.userId + clientVars.collab_client_vars.client.sid.slice(0, 5),
        userid: clientVars.userId,
        module: MODULE_TAG,
        // TODO: 目前调试先用旧 clientVars 的 tinyid，新版本 clientVars 里会直接 html 直出 uid, 到时候替换即可
        uid: clientVars.tinyid
      };
      // 初始化 connectionController
      this.connectionController = new ConnectionController(options);
      // 添加事件监听
      this.connectionController.onConnectionEvent(function (result) {
        _this3.dispathEvent(result);
      });
    }
    /**
     * 在这里添加新的 connectionController event handler
     */
  }, {
    key: "configEventHandlerMap",
    value: function configEventHandlerMap() {
      var _this4 = this;
      this.eventHandlerMap = {
        onEnterOnline: function onEnterOnline() {
          return _this4.onEnterOnlineEmitter.fire(undefined);
        },
        onEnterOffline: function onEnterOffline() {
          return _this4.onEnterOfflineEmitter.fire(undefined);
        },
        onNetReconnectedFail: function onNetReconnectedFail() {
          return _this4.onNetReconnectedFailEmitter.fire(undefined);
        },
        onRoomStateChange: function onRoomStateChange(result) {
          var _a;
          _this4.onRoomStateChangeEmitter.fire((_a = result.data) === null || _a === void 0 ? void 0 : _a.roomState);
        }
      };
    }
    /**
     * 在这里添加新的 ReceiveMsgFromServer 事件对应的 msg 的 handler
     */
  }, {
    key: "configMsgHandlerMap",
    value: function configMsgHandlerMap() {
      var _this5 = this;
      this.msgHandlerMap = {
        // 删除文档通知
        HANDLE_DELETE: function HANDLE_DELETE() {
          return _this5.handleDelete();
        },
        // 还原文档通知
        REVERT_MESSAGE: function REVERT_MESSAGE() {
          return _this5.handleRevertMessage();
        },
        // 权限变更通知
        RIGHT_MESSAGE: function RIGHT_MESSAGE(messages) {
          return _this5.handleRightMessage(messages);
        },
        // 文档标题变更通知
        TITLE_MESSAGE: function TITLE_MESSAGE(messages) {
          return _this5.handleTitleMessage(messages);
        },
        // 单个用户进入房间通知
        USER_NEWINFO: function USER_NEWINFO(messages) {
          return _this5.handleNewUserInfo(messages);
        },
        // 批量用户进入房间通知
        USER_NEWINFOS: function USER_NEWINFOS(messages) {
          return _this5.handleNewUserInfos(messages);
        },
        // 单个用户离开房间通知
        USER_LEAVE: function USER_LEAVE(messages) {
          return _this5.handleUserLeave(messages);
        },
        // 批量用户离开房间通知
        USER_LEAVES: function USER_LEAVES(messages) {
          return _this5.handleUserLeaves(messages);
        },
        // 个性赞广播消息 [这个命令字和下面的长的太像了，容易搞混]
        COMMERCIALIZE_MESSAGE: function COMMERCIALIZE_MESSAGE(messages) {
          return _this5.handleCommerCializeMessage(messages);
        },
        // 商业化 vip 相关消息
        COMMERICILIZE_MESSAGE: function COMMERICILIZE_MESSAGE(messages) {
          return _this5.handleCommerIcilizeMessage(messages);
        },
        // 水印相关消息
        MARK_MESSAGE: function MARK_MESSAGE(messages) {
          return _this5.handleMarkMessage(messages);
        },
        // 通用通知（里面还分不同子类型）
        COMM_NOTICE: function COMM_NOTICE(messages) {
          return _this5.handleCommNotice(messages);
        }
      };
    }
    /**
     * 处理 RoomShutDown 消息
     * 根据消息类型，分发到各个 domainService 里由 domainService 统一分发到 Feature
     * @param serverMsg: @IConnectionCallBackServerMsg
     */
  }, {
    key: "onRoomShutDown",
    value: function onRoomShutDown(closeReason) {
      if (!closeReason) {
        this.logger.info('info  = onRoomShutDown = type or closeReason is null');
        return;
      }
      var _closeReason$errCode = closeReason.errCode,
        errCode = _closeReason$errCode === void 0 ? 0 : _closeReason$errCode;
      if (errCode === 72105 /* SHUTDOWN_CODE.USER_INITIATIVE */) {
        this.logger.info('info  = onRoomShutDown = type or errCode === USER_SHUTDOWN_CODE');
        return;
      }
    }
    /**
     * 处理服务器推送消息数据
     * 根据消息类型，分发到各个 domainService 里由 domainService 统一分发到 Feature
     * @param serverMsg: @IConnectionCallBackServerMsg
     */
  }, {
    key: "onReceiveMsgFromServer",
    value: function onReceiveMsgFromServer(serverMsg) {
      if (!(serverMsg === null || serverMsg === void 0 ? void 0 : serverMsg.type) || !isArray(serverMsg === null || serverMsg === void 0 ? void 0 : serverMsg.data)) {
        this.logger.error('error = onReceiveMsgFromServer, type or receiveData.data is null');
        return;
      }
      var type = serverMsg.type,
        data = serverMsg.data;
      var handler = this.msgHandlerMap[type];
      if (handler) {
        handler(data);
      }
    }
    /**
     * 分发 connectionController 事件
     * @param result
     */
  }, {
    key: "dispathEvent",
    value: function dispathEvent(result) {
      var _a, _b;
      var handler = this.eventHandlerMap[result.event];
      // 只处理需要 app service 向外暴露的事件
      if (handler) {
        handler(result);
      } else if (result.event === "OnReceiveMsgFromServer" /* ConnectionCallBackEvent.onReceiveMsgFromServer */) {
        this.onReceiveMsgFromServer((_a = result.data) === null || _a === void 0 ? void 0 : _a.serverMsg);
      } else if (result.event === "OnRoomShutDown" /* ConnectionCallBackEvent.onRoomShutDown */) {
        this.onRoomShutDown((_b = result.data) === null || _b === void 0 ? void 0 : _b.closeReason);
      }
      // 其它事件不处理
    }
  }, {
    key: "handleDelete",
    value: function handleDelete() {
      this.docMetaDomain.docMetaEntity.handleNoticeDeleted();
    }
  }, {
    key: "handleRevertMessage",
    value: function handleRevertMessage() {
      this.logger.debug('REVERT_MESSAGE');
    }
  }, {
    key: "handleRightMessage",
    value: function handleRightMessage(messages) {
      var _this6 = this;
      this.logger.debug('RIGHT_MESSAGE');
      messages.forEach(function (data) {
        var _a;
        var authInfoEntity = _this6.authDomain.authAggregate.authInfoEntity;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
        // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
        authInfoEntity.onReceiveMessageFromServer((_a = data === null || data === void 0 ? void 0 : data.body) === null || _a === void 0 ? void 0 : _a.notice, _this6.connectionController);
      });
    }
  }, {
    key: "handleTitleMessage",
    value: function handleTitleMessage(messages) {
      var _this7 = this;
      messages.forEach(function (data) {
        var notice = data.body.notice;
        var docMetaEntity = _this7.docMetaDomain.docMetaEntity;
        docMetaEntity.handleNoticeTitleChanged(notice.title);
      });
    }
  }, {
    key: "handleNewUserInfo",
    value: function handleNewUserInfo(messages) {
      var _this8 = this;
      messages.forEach(function (data) {
        var notice = data.body.notice;
        var tempNotice = {
          sessionType: notice.session_type,
          userId: notice.userId,
          uuId: notice.uuId,
          vipInfo: notice.vip_info
        };
        var notices = {
          memCount: notice.mem_count,
          notices: [tempNotice]
        };
        var collaborateAggregate = _this8.collaborateDomain.collaborateAggregate;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
        // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
        collaborateAggregate.handleUserComeIn(notices);
      });
    }
  }, {
    key: "handleNewUserInfos",
    value: function handleNewUserInfos(messages) {
      var _this9 = this;
      messages.forEach(function (data) {
        // IServerMessageBody 没定义notices这个字段，但是会真实存在, 后边虎大爷加上把ignore删掉
        var _data$body = data.body,
          notices = _data$body.notices,
          mem_count = _data$body.mem_count;
        var tempNotices = [];
        notices === null || notices === void 0 ? void 0 : notices.forEach(function (notice) {
          var newNotice = {
            sessionType: notice.session_type,
            userId: notice.userId,
            uuId: notice.uuId,
            vipInfo: notice.vip_info
          };
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
          // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
          tempNotices.push(newNotice);
        });
        var comeInNotices = {
          memCount: mem_count,
          notices: tempNotices
        };
        var collaborateAggregate = _this9.collaborateDomain.collaborateAggregate;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
        // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
        collaborateAggregate.handleUserComeIn(comeInNotices);
      });
    }
  }, {
    key: "handleUserLeave",
    value: function handleUserLeave(messages) {
      var _this10 = this;
      messages.forEach(function (data) {
        var notice = data.body.notice;
        var newNotice = {
          sessionType: notice.session_type,
          userId: notice.userId,
          uuId: notice.uuId,
          vipInfo: notice.vip_info
        };
        var leaveNotices = {
          memCount: notice.mem_count,
          notices: [newNotice]
        };
        var collaborateAggregate = _this10.collaborateDomain.collaborateAggregate;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
        // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
        collaborateAggregate.handleUserLeave(leaveNotices);
      });
    }
  }, {
    key: "handleUserLeaves",
    value: function handleUserLeaves(messages) {
      var _this11 = this;
      messages.forEach(function (data) {
        // IServerMessageBody 没定义notices这个字段，但是会真实存在, 后边虎大爷加上把 ignore 删掉
        var _data$body2 = data.body,
          notices = _data$body2.notices,
          mem_count = _data$body2.mem_count;
        var tempNotices = [];
        notices === null || notices === void 0 ? void 0 : notices.forEach(function (notice) {
          var newNotice = {
            sessionType: notice.session_type,
            userId: notice.userId,
            uuId: notice.uuId,
            vipInfo: notice.vip_info
          };
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
          // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
          tempNotices.push(newNotice);
        });
        var leaveNotices = {
          memCount: mem_count,
          notices: tempNotices
        };
        var collaborateAggregate = _this11.collaborateDomain.collaborateAggregate;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
        // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
        collaborateAggregate.handleUserLeave(leaveNotices);
      });
    }
  }, {
    key: "handleCommerCializeMessage",
    value: function handleCommerCializeMessage(messages) {
      var _this12 = this;
      this.likeDomain.likeEntity.handleRealTimeLikeMessage(messages);
      messages.forEach(function (data) {
        var collaborateAggregate = _this12.collaborateDomain.collaborateAggregate;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
        // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
        collaborateAggregate.handleCommerIcilizeMessage(data);
      });
    }
  }, {
    key: "handleCommerIcilizeMessage",
    value: function handleCommerIcilizeMessage(messages) {
      var _this13 = this;
      messages.forEach(function (data) {
        var collaborateAggregate = _this13.collaborateDomain.collaborateAggregate;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
        // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
        collaborateAggregate.handleCommerIcilizeMessage(data);
      });
    }
  }, {
    key: "handleMarkMessage",
    value: function handleMarkMessage(messages) {
      this.logger.debug(messages);
    }
  }, {
    key: "handleCommNotice",
    value: function handleCommNotice(messages) {
      var _this14 = this;
      this.logger.debug(messages);
      // 协作人数变化
      messages.forEach(function (data) {
        var _a, _b, _c;
        var collaborateAggregate = _this14.collaborateDomain.collaborateAggregate;
        if (((_b = (_a = data === null || data === void 0 ? void 0 : data.body) === null || _a === void 0 ? void 0 : _a.notice) === null || _b === void 0 ? void 0 : _b.type) === ServerMessageNoticeEventType.COLLAB_COUNT_CHANGE) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment,
          // @ts-ignore 目前 @tencent/collabroom 库少types定义，先 ignore
          collaborateAggregate.onReceiveMessageFromServer((_c = data === null || data === void 0 ? void 0 : data.body) === null || _c === void 0 ? void 0 : _c.notice);
        }
      });
    }
  }]);
  return ConnectionControllerService;
}(Disposable);
__decorate([releaseLock('init'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], ConnectionControllerService.prototype, "dispose", null);
__decorate([lockOnce(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], ConnectionControllerService.prototype, "init", null);
ConnectionControllerService = __decorate([__param(0, IDocMetaDomainService), __param(1, IAuthDomainService), __param(2, ICollaborateDomainService), __param(3, ILikeDomainService), __metadata("design:paramtypes", [Object, Object, Object, Object])], ConnectionControllerService);

var npmConfig = appConfigInstance.getConfig('npm["@tencent/ark-application"]');
var LOCATION_HOST = window.location.host;
(npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TENCENT_DOCS_HOME) || 'docs.qq.com/desktop';
new RegExp((npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TENCENT_DOCS_EDITOR_REGEXP) || 'docs\\.qq\\.com\\/.+\\/[BD].+');
(npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.WECOM_DOCS_HOME) || 'doc.weixin.qq.com/home';
var WECOM_DOCS_EDITOR = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.WECOM_DOCS_EDITOR) || 'doc.weixin.qq.com';
var FEEDBACK_URL = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.FEEDBACK_URL) || 'https://support.qq.com/product/28096';
var EXACTLY_PARENT_TOC_COOKIE_DOMAIN = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.EXACTLY_PARENT_TOC_COOKIE_DOMAIN) || 'qq.com';
var PARENT_TOC_COOKIE_DOMAIN = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.PARENT_TOC_COOKIE_DOMAIN) || '.qq.com';
var TOC_COOKIE_DOMAIN = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOC_COOKIE_DOMAIN) || '.docs.qq.com';
var PARENT_TOB_COOKIE_DOMAIN = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.PARENT_TOB_COOKIE_DOMAIN) || '.weixin.qq.com';
var TOB_COOKIE_DOMAIN = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOB_COOKIE_DOMAIN) || '.doc.weixin.qq.com';
var WECOM_HOME_PAGE = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.WECOM_HOME_PAGE) || 'https://doc.weixin.qq.com/home/recent';
(npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.PAGE_JUMP_TO_C) || 'https://doc.weixin.qq.com/scenario/page-jump-to-c.html?redirect_uri=';
new RegExp((npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOC_HOME_PAGE_REGEXP) || 'docs\\.qq\\.com\\/desktop(\\/)?', 'i');
var TOB_LOGIN_PAGE_URL = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOB_LOGIN_PAGE_URL) || 'https://doc.weixin.qq.com/disklogin/login';
var TOC_HOME_PAGE = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOC_HOME_PAGE) || 'https://docs.qq.com/desktop';
var C_JUMP_TO_B_URL = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.C_JUMP_TO_B_URL) || 'https://docs.qq.com/scenario/page-jump-to-b.html';
(npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.C_JUMP_TOB_LOGIN_PAGE_URL) || 'https://docs.qq.com/v2/user/workwx/login';
var C_LOGIN_URL = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.C_LOGIN_URL) || 'https://docs.qq.com/scenario/login.html';
new RegExp((npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOB_HOME_PAGE_REGEXP) || 'doc\\.weixin\\.qq\\.com\\/home\\/recent(\\/)?', 'i');
new RegExp((npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOB_MALL_PAGE_REGEXP) || 'doc\\.weixin\\.qq\\.com\\/mall\\/index(\\/)?', 'i');
new RegExp((npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOC_MALL_PAGE_REGEXP) || 'docs\\.qq\\.com\\/mall(\\/)?', 'i');
(npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOC_MALL_PAGE) || 'https://docs.qq.com/mall/index';

/*
 * 获取跳到吐个槽的参数信息
*/
function gotoFeedback() {
  var _a, _b, _c, _d, _e;
  var isIPad = ua.isIPad,
    isTencentDocsApp = ua.isTencentDocsApp,
    isMiniProgram = ua.isMiniProgram;
  var isTencentDocsAppInIpad = isIPad && isTencentDocsApp;
  var userAgent = encodeURIComponent(navigator.userAgent);
  var href = encodeURIComponent(location.href);
  var url = "".concat(FEEDBACK_URL, "?clientInfo=").concat(userAgent, "&customInfo=").concat(href);
  var mqq = ((_c = (_b = (_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.mqq) === null || _a === void 0 ? void 0 : _a.QQVersion) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b)) !== '0';
  if (isMiniProgram) {
    location.href = url;
  } else if (!isTencentDocsAppInIpad && mqq) {
    (_e = (_d = globalThis === null || globalThis === void 0 ? void 0 : globalThis.mqq) === null || _d === void 0 ? void 0 : _d.ui) === null || _e === void 0 ? void 0 : _e.openUrl({
      url: url,
      target: 1,
      style: 1
    });
  } else {
    globalThis === null || globalThis === void 0 ? void 0 : globalThis.open(url);
  }
}
/**
 * connectionService 的统一弹error提示类
 */
var ConnectionShowTips = /*#__PURE__*/_createClass(function ConnectionShowTips() {
  _classCallCheck(this, ConnectionShowTips);
  /**
   * tips button 点击事件消费
   */
  this.actionCallBack = {
    /**
     * 刷新
     */
    refresh: {
      text: '刷新',
      onClick: function onClick() {
        location.reload();
      }
    },
    /**
     * 刷新并修复
     */
    refreshAndFix: {
      text: '刷新',
      onClick: function onClick() {
        location.reload();
      }
    },
    /**
     * 联系我们
     */
    contact: {
      text: '联系我们',
      onClick: function onClick() {
        gotoFeedback();
      }
    },
    /**
     * 如何处理
     */
    howToDeal: {
      text: '如何处理',
      onClick: function onClick() {
        // 目前只有   你的权限已发生变化，点击刷新。
        location.reload();
      }
    },
    /**
     * 了解更多
     */
    learnMore: {
      text: '了解更多',
      onClick: function onClick() {
        // TODO: 目前不涉及品类编辑，先空实现，后补
      }
    }
  };
});

var SWR_FETCHER_MAP_METADAT_KEY = Symbol["for"]('swr-decorator:fetcherMap');
/**
 * 被 @SWRFetcher 装饰器装饰的类方法会在调用 mutate(key) 时执行，执行结束后更新对应的属性值
 *
 * @param {string} key - 类方法将更新的对应属性名
 */
function SWRFetcher(key) {
  return function (target, propertyName) {
    var fetcherMap = Reflect.getMetadata(SWR_FETCHER_MAP_METADAT_KEY, target) || new Map();
    fetcherMap.set(key, propertyName);
    Reflect.defineMetadata(SWR_FETCHER_MAP_METADAT_KEY, fetcherMap, target);
  };
}

var SWR_PROPERTIES_METADAT_KEY = Symbol["for"]('swr-decorator:properties');
/**
 * 标注为需要使用 SWR 机制的属性，被标注的属性可以自动被使用 @SWRFetcher 装饰的类的方法更新
 * 并且能够通过 subscribe(key: string, callback: Function) 方法订阅更新
 *
 * @param {any} target - 装饰的类属性
 * @param {string} propertyName - 装饰的类属性名称
 */
function SWRProperty(target, propertyName) {
  var _a;
  var propertiesMetadata = (_a = Reflect.getMetadata(SWR_PROPERTIES_METADAT_KEY, target)) !== null && _a !== void 0 ? _a : [];
  propertiesMetadata.push(propertyName);
  Reflect.defineMetadata(SWR_PROPERTIES_METADAT_KEY, propertiesMetadata, target);
}

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PropertyState = /*#__PURE__*/function () {
  function PropertyState(value, fetcher) {
    var updatePropertiesOnFirstRequire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _classCallCheck(this, PropertyState);
    this.value = value;
    this.fetcher = fetcher;
    this.subscribers = new Set();
    this.validating = false;
    this.firstRequire = false;
    this.updatePropertiesOnFirstRequire = updatePropertiesOnFirstRequire;
  }
  _createClass(PropertyState, [{
    key: "getValue",
    value: function getValue() {
      var _this = this;
      if (this.updatePropertiesOnFirstRequire && !this.firstRequire) {
        setTimeout(function () {
          return _this.revalidate();
        }, 0);
        this.firstRequire = true;
      }
      return this.value;
    }
  }, {
    key: "getValueMutate",
    value: function getValueMutate() {
      this.revalidate();
      return this.value;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var slient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.value = value;
      if (!slient) {
        this.subscribers.forEach(function (subscriber) {
          return subscriber(value);
        });
      }
      return true;
    }
  }, {
    key: "addSubscriber",
    value: function addSubscriber(subscriber) {
      this.subscribers.add(subscriber);
    }
  }, {
    key: "removeSubscriber",
    value: function removeSubscriber(subscriber) {
      this.subscribers["delete"](subscriber);
    }
  }, {
    key: "isValidating",
    value: function isValidating() {
      return this.validating;
    }
  }, {
    key: "revalidate",
    value: function revalidate() {
      var _this2 = this;
      if (this.validating) {
        return;
      }
      if (!this.fetcher) {
        return;
      }
      this.validating = true;
      this.fetcher().then(function (value) {
        _this2.validating = false;
        _this2.setValue(value);
      })["catch"](function (error) {
        _this2.validating = false;
        throw error;
      });
    }
  }]);
  return PropertyState;
}();
/**
 * 类 SWR 机制装饰器，在类上使用后可以对类的属性/方法进行装饰
 * 使其可以使用类似 SWR 的机制进行数据的更新与订阅
 *
 * @example
 * @SWRProvider()
 * class UserInfo {
 *   @SWRProperty() public nickname: string;
 *
 *   @SWRFetcher('nickname')
 *   private async fetchNickname() {
 *     // ...
 *   }
 * }
 *
 * const userInfo = new UserInfo();
 * // 获取 nickname 的值
 * userInfo.nickname; // undefined
 * // 触发执行 fetchNickname 进行更新
 * userInfo.mutate('nickname');
 * // 直接修改 nickname 的值，并且触发执行 fetchNickname 进行更新
 * userInfo.mutate('nickname', 'test');
 * // 当 nickname 的值发生变化时，触发回调
 * userInfo.subscribe('nickname', (value) => {
 *   console.log(value);
 * });
 */
function SWRProvider(providerOptions) {
  var _ref = providerOptions !== null && providerOptions !== void 0 ? providerOptions : {},
    updatePropertiesOnFirstRequire = _ref.updatePropertiesOnFirstRequire;
  // eslint-disable-next-line @typescript-eslint/ban-types
  return function (constructor) {
    var properties = new Map();
    return /*#__PURE__*/function (_constructor) {
      _inherits(_class, _constructor);
      var _super = _createSuper$2(_class);
      function _class() {
        var _this3;
        _classCallCheck(this, _class);
        var _a, _b;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this3 = _super.call.apply(_super, [this].concat(args));
        var proxy = {};
        var fetcherMap = (_a = Reflect.getMetadata(SWR_FETCHER_MAP_METADAT_KEY, _assertThisInitialized(_this3))) !== null && _a !== void 0 ? _a : new Map();
        var propertyNames = (_b = Reflect.getMetadata(SWR_PROPERTIES_METADAT_KEY, _assertThisInitialized(_this3))) !== null && _b !== void 0 ? _b : [];
        propertyNames.forEach(function (key) {
          var _a;
          var fetcherName = fetcherMap.get(key);
          var fetcherFn = (_a = _this3[fetcherName]) === null || _a === void 0 ? void 0 : _a.bind(_assertThisInitialized(_this3));
          var propertyState = new PropertyState(_this3[key], fetcherFn, updatePropertiesOnFirstRequire);
          properties.set(key, propertyState);
          proxy[key] = {
            get: function get() {
              return propertyState.getValue();
            },
            set: function set(value) {
              propertyState.setValue(value);
              return true;
            }
          };
          _this3[fetcherName] = function () {
            for (var _len2 = arguments.length, fetcherArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              fetcherArgs[_key2] = arguments[_key2];
            }
            return __awaiter(_assertThisInitialized(_this3), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var newVal;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return fetcherFn.apply(void 0, fetcherArgs);
                  case 2:
                    newVal = _context.sent;
                    propertyState.setValue(newVal);
                    return _context.abrupt("return", newVal);
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
          };
        });
        Object.defineProperties(_assertThisInitialized(_this3), proxy);
        return _this3;
      }
      _createClass(_class, [{
        key: "isValidating",
        value: function isValidating(key) {
          var _a, _b;
          return (_b = (_a = properties.get(key)) === null || _a === void 0 ? void 0 : _a.isValidating()) !== null && _b !== void 0 ? _b : false;
        }
      }, {
        key: "subscribe",
        value: function subscribe(key, fn) {
          var _a;
          (_a = properties.get(key)) === null || _a === void 0 ? void 0 : _a.addSubscriber(fn);
          return function () {
            var _a;
            (_a = properties.get(key)) === null || _a === void 0 ? void 0 : _a.removeSubscriber(fn);
          };
        }
      }, {
        key: "mutate",
        value: function mutate(key_1, data_1) {
          return __awaiter(this, arguments, void 0, function (key, data) {
            var shouldRevalidate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var _a, _b;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (data !== undefined) {
                      (_a = properties.get(key)) === null || _a === void 0 ? void 0 : _a.setValue(data, true);
                    }
                    if (shouldRevalidate) {
                      (_b = properties.get(key)) === null || _b === void 0 ? void 0 : _b.revalidate();
                    }
                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            })();
          });
        }
      }]);
      return _class;
    }(constructor);
  };
}

var dictRaw = {
  nick: 'nickname',
  avatar: 'avatarURI',
  uType: 'accountType',
  phone: 'phoneNumber',
  isHasPassword: 'enabled',
  utype: 'accountType',
  uin: 'qq'
};
var dict = {
  raw: dictRaw,
  words: Object.keys(dictRaw)
};

// compatible with global
// 目前浏览器环境、Jest环境(jsDom)都有global
// node环境先简单mock一下。   后续补齐 or 是不是node环境也jsDom处理一下呢？
var MOCK_GLOBAL = {};
function isInBrowser() {
  return typeof window !== 'undefined';
}
function isInNodeJS() {
  return typeof global !== 'undefined';
}
function isInWebWorker() {
  return !isInBrowser && typeof self !== 'undefined';
}
function isInJestEnv() {
  return isInNodeJS() && typeof global.describe === 'function';
}
/**
 * 获取全局变量
 */
function getGlobalObject() {
  if (isInBrowser()) {
    return window;
  }
  if (isInNodeJS()) {
    return global;
  }
  if (isInWebWorker()) {
    return self;
  }
  if (isInJestEnv()) {
    return MOCK_GLOBAL;
  }
  return MOCK_GLOBAL;
}
var browserUtilsGlobal = getGlobalObject();
var global$1 = browserUtilsGlobal;

/**
 * 判断Object是否有key属性
 * @category Object
 * @param {obj} 被判断的对象
 * @param {key} 要检查的key属性名
 * @returns {boolean} true: 表示属性存在; false: 属性不存在
 */
function has(obj, key) {
  return obj !== null && Object.prototype.hasOwnProperty.call(obj, key);
}

// localStorage 属性名
var LOCATION_PREPROTY = 'location';
/**
 * get search
 * @returns {string}     [value]         // docs.qq.com
 */
function getSearch() {
  if (!has(global$1, LOCATION_PREPROTY)) {
    // node环境目前简单处理，后续需要mock再处理；
    return '';
  }
  return location.search;
}
/**
 * get query param
 * @param  {string} key [key]
 * @returns {string}     [value]
 */
function getQuery(key, options) {
  if (options === void 0) {
    options = {
      shouldDecodeURI: false
    };
  }
  if (!has(global$1, LOCATION_PREPROTY)) {
    // node环境目前简单处理，后续需要mock再处理；
    return '';
  }
  var reg = new RegExp("(\\?|&)".concat(key, "=([^&]*)(#|&|$)"));
  var searchStr = (options === null || options === void 0 ? void 0 : options.shouldDecodeURI) ? decodeURIComponent(getSearch()) : getSearch();
  var result = searchStr.match(reg);
  return !result ? '' : decodeURIComponent(result[2]);
}

var DOC_PATH_NAME = ['/doc/', '/sheet/', '/slide/', '/form/', '/mind/', '/flowchart/', '/pdf/'];
var AccountApplicationOfflineService = /*#__PURE__*/function () {
  function AccountApplicationOfflineService() {
    _classCallCheck(this, AccountApplicationOfflineService);
    // 小程序中依赖的一些能力, 特别是 IndexedDB, 基本不可用. 另外小程序也没必要离线.
    if (ua.isMiniProgram) return new StubAccountApplicationOfflineService();
    try {
      // indexDB 在低版本微信下无实现&接口不兼容，会出现白屏
      var storageManager = new StorageManager({
        type: this.isSupportClientDB() ? DBEngineType.nativeDB : DBEngineType.indexDB,
        disableAutoOpen: false
      });
      var userInfoCollection = storageManager.storage.collection(UserInfo);
      this.userInfoStorage = new UserInfoStorage(userInfoCollection);
      this.onOfflineState = false;
    } catch (err) {
      console.error(err);
      return new StubAccountApplicationOfflineService();
    }
  }
  _createClass(AccountApplicationOfflineService, [{
    key: "setOnOfflineState",
    value: function setOnOfflineState(state) {
      this.onOfflineState = state;
    }
  }, {
    key: "addUserInfo",
    value: function addUserInfo(data) {
      // 离线的时候不用触发该请求
      if (!network || !network.isOnline) {
        return;
      }
      if (this.onOfflineState) {
        return;
      }
      if (!(data === null || data === void 0 ? void 0 : data.tinyId) || data.tinyId === NOT_LOGIN_TINYID) {
        return;
      }
      var userInfo = new UserInfo(Object.assign(Object.assign({}, data), this.getDocInfo()));
      this.userInfoStorage.addUserInfo(userInfo);
    }
  }, {
    key: "updateUserInfo",
    value: function updateUserInfo(data) {
      // 离线的时候不用触发该请求
      if (!network || !network.isOnline) {
        return;
      }
      if (data.tinyId === NOT_LOGIN_TINYID || this.onOfflineState) {
        return;
      }
      this.userInfoStorage.updateUserInfo({
        tinyId: data.tinyId
      }, data);
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var nowUserIndex, _this$getDocInfo, pageType, docId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              nowUserIndex = getQuery('u');
              if (!nowUserIndex) {
                _context.next = 7;
                break;
              }
              _context.t0 = this;
              _context.next = 5;
              return this.userInfoStorage.getUserInfoByNowUserIndex(nowUserIndex);
            case 5:
              _context.t1 = _context.sent;
              return _context.abrupt("return", _context.t0.changeOfflineData.call(_context.t0, _context.t1));
            case 7:
              _this$getDocInfo = this.getDocInfo(), pageType = _this$getDocInfo.pageType, docId = _this$getDocInfo.docId;
              _context.t2 = this;
              _context.next = 11;
              return this.userInfoStorage.getUserInfoByDocInfo(pageType, docId);
            case 11:
              _context.t3 = _context.sent;
              return _context.abrupt("return", _context.t2.changeOfflineData.call(_context.t2, _context.t3));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "changeOfflineData",
    value: function changeOfflineData(userInfoOfflineData) {
      if (!userInfoOfflineData) {
        return null;
      }
      var userInfo = {
        tinyId: userInfoOfflineData.tinyId,
        corpId: userInfoOfflineData.corpId,
        corpName: userInfoOfflineData.corpName,
        englishName: userInfoOfflineData.englishName,
        loginType: userInfoOfflineData.loginType,
        uidSource: userInfoOfflineData.uidSource,
        openId: userInfoOfflineData.openId,
        uin: userInfoOfflineData.uin,
        userId: userInfoOfflineData.userId,
        userName: userInfoOfflineData.userName,
        userPic: userInfoOfflineData.userPic,
        nowUserIndex: userInfoOfflineData.nowUserIndex,
        settings: userInfoOfflineData.settings,
        wedriveUin: userInfoOfflineData.wedriveUin || ''
      };
      var bindUserInfo = userInfoOfflineData.bindUserInfo,
        vipUserInfo = userInfoOfflineData.vipUserInfo;
      var vipInfo = vipUserInfo;
      return {
        userInfo: userInfo,
        vipInfo: vipInfo,
        bindUserInfo: bindUserInfo
      };
    }
  }, {
    key: "isSupportClientDB",
    value: function isSupportClientDB() {
      var tdocFlag = /_tdocFlag\/(\d+)/.exec(navigator.userAgent);
      if (tdocFlag === null || tdocFlag === void 0 ? void 0 : tdocFlag[1]) {
        var num = parseInt(tdocFlag[1], 10);
        return (num & 0x2) > 0;
      }
      return false;
    }
  }, {
    key: "getDocInfo",
    value: function getDocInfo() {
      var pathNameArr = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location.pathname.split('/');
      var pageType = pathNameArr[1];
      var isDoc = DOC_PATH_NAME.filter(function (item) {
        return globalThis.location.pathname.includes(item);
      }).length > 0;
      if (!isDoc) {
        return {
          pageType: pageType,
          docId: pageType,
          updateTime: Date.now().toString()
        };
      }
      return {
        pageType: pageType,
        docId: pathNameArr[2],
        updateTime: Date.now().toString()
      };
    }
  }]);
  return AccountApplicationOfflineService;
}();
var StubAccountApplicationOfflineService = /*#__PURE__*/function () {
  function StubAccountApplicationOfflineService() {
    _classCallCheck(this, StubAccountApplicationOfflineService);
  }
  _createClass(StubAccountApplicationOfflineService, [{
    key: "setOnOfflineState",
    value: function setOnOfflineState() {}
  }, {
    key: "addUserInfo",
    value: function addUserInfo() {}
  }, {
    key: "updateUserInfo",
    value: function updateUserInfo() {}
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      return Promise.resolve(null);
    }
  }]);
  return StubAccountApplicationOfflineService;
}();

var DELETE_ACCOUNT_FOR_LIST_STATE;
(function (DELETE_ACCOUNT_FOR_LIST_STATE) {
  DELETE_ACCOUNT_FOR_LIST_STATE["SUCCESS"] = "SUCCESS";
  DELETE_ACCOUNT_FOR_LIST_STATE["MAIN_SUCCESS_SECOND_FAIL"] = "MAIN_SUCCESS_SECOND_FAIL";
  DELETE_ACCOUNT_FOR_LIST_STATE["MAIN_FAIL_SECOND_SUCCESS"] = "MAIN_FAIL_SECOND_SUCCESS";
  DELETE_ACCOUNT_FOR_LIST_STATE["FAIL"] = "FAIL";
  DELETE_ACCOUNT_FOR_LIST_STATE["NOT_EXIST"] = "NOT_EXIST"; // 账号ID不存在在列表中
})(DELETE_ACCOUNT_FOR_LIST_STATE || (DELETE_ACCOUNT_FOR_LIST_STATE = {}));

var AccountListApplicationService = /*#__PURE__*/function () {
  function AccountListApplicationService(accountDomainService, messageDomainService) {
    _classCallCheck(this, AccountListApplicationService);
    this.accountDomainService = accountDomainService;
    this.messageDomainService = messageDomainService;
  }
  _createClass(AccountListApplicationService, [{
    key: "getPersonalAccountList",
    value: function getPersonalAccountList(padID, folderID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getFetchAccountList(padID, folderID);
            case 2:
              this.fetchAccountList = _context.sent;
              return _context.abrupt("return", this.mergeAccountList(this.fetchAccountList, []));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getFetchAccountList",
    value: function getFetchAccountList(padID, folderID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.accountDomainService.accountAggregate.accountListEntity.getAccountList(padID, folderID);
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "deleteAccountForList",
    value: function deleteAccountForList(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var uid, userIndex, isSuccessDeleteForFetchAccountList, isAccountInFetchAccountList;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              uid = account.uid, userIndex = account.userIndex;
              isSuccessDeleteForFetchAccountList = true;
              isAccountInFetchAccountList = this.isHasSameTinyID(this.fetchAccountList, uid); // 删除C侧列表
              if (!isAccountInFetchAccountList) {
                _context3.next = 7;
                break;
              }
              _context3.next = 6;
              return this.deleteFetchAccountList(account);
            case 6:
              isSuccessDeleteForFetchAccountList = _context3.sent;
            case 7:
              // 两个tab用不同账号打开，在其中一个tab退出了另一个tab的账号，被退出账号的tab收到通知，防止被退出账号携带无效u发起请求
              if (isSuccessDeleteForFetchAccountList) {
                MsgCenter.postMessage({
                  type: ILogoutMessageType.LOGOUT,
                  data: userIndex,
                  needCookie: true
                });
              }
              // 由于没有 B 端账号的数据源，所以下掉了 B 端账号的删除逻辑
              return _context3.abrupt("return", this.changeDeleteAccountState(isSuccessDeleteForFetchAccountList, true));
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "changeSign",
    value: function changeSign(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var userIndex;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              userIndex = account.userIndex;
              if (userIndex) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", false);
            case 3:
              _context4.next = 5;
              return this.accountDomainService.accountAggregate.accountListEntity.changeSign(userIndex);
            case 5:
              return _context4.abrupt("return", _context4.sent);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.messageDomainService.getEnterpriseAccountListMessage.dispose();
    }
  }, {
    key: "changeDeleteAccountState",
    value: function changeDeleteAccountState(isSuccessDeleteForFetchAccountList, isSuccessDeleteForEnterpriseAccountList) {
      if (isSuccessDeleteForFetchAccountList && isSuccessDeleteForEnterpriseAccountList) {
        return DELETE_ACCOUNT_FOR_LIST_STATE.SUCCESS;
      }
      if (isSuccessDeleteForFetchAccountList) {
        return DELETE_ACCOUNT_FOR_LIST_STATE.MAIN_SUCCESS_SECOND_FAIL;
      }
      if (isSuccessDeleteForEnterpriseAccountList) {
        return DELETE_ACCOUNT_FOR_LIST_STATE.MAIN_FAIL_SECOND_SUCCESS;
      }
      return DELETE_ACCOUNT_FOR_LIST_STATE.FAIL;
    }
  }, {
    key: "deleteFetchAccountList",
    value: function deleteFetchAccountList(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var userIndex;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              userIndex = account.userIndex;
              if (userIndex) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return", false);
            case 3:
              _context5.next = 5;
              return this.accountDomainService.accountAggregate.accountListEntity.delAccountForList(userIndex);
            case 5:
              return _context5.abrupt("return", _context5.sent);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "mergeAccountList",
    value: function mergeAccountList(highWeightArray, lowWeightArray) {
      var _this = this;
      return lowWeightArray.reduce(function (prevArray, current) {
        if (_this.isHasSameTinyID(prevArray, current.uid)) {
          return prevArray;
        }
        return [].concat(_toConsumableArray(prevArray), [current]);
      }, highWeightArray);
    }
  }, {
    key: "isHasSameTinyID",
    value: function isHasSameTinyID(accountList, uid) {
      return accountList.some(function (item) {
        if (item.uid === uid) {
          return true;
        }
        return false;
      });
    }
  }, {
    key: "getEnterpriseAccountList",
    value: function getEnterpriseAccountList() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;
        var userList;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.messageDomainService.getEnterpriseAccountListMessage.connect();
              this.getIframeMountMessage();
              this.messageDomainService.getEnterpriseAccountListMessage.createGetAccountListIframe(function () {
                _this2.messageDomainService.getEnterpriseAccountListMessage.sendAccountListMessage();
              });
              _context6.next = 5;
              return this.getAccountListMessage();
            case 5:
              userList = _context6.sent;
              return _context6.abrupt("return", userList);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "deleteEnterpriseAccountList",
    value: function deleteEnterpriseAccountList(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var cookie;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              cookie = account.cookie;
              if (cookie) {
                _context7.next = 3;
                break;
              }
              return _context7.abrupt("return", false);
            case 3:
              this.messageDomainService.getEnterpriseAccountListMessage.sendDeleteAccountMessage(cookie);
              _context7.next = 6;
              return this.getDeleteAccountMessage();
            case 6:
              return _context7.abrupt("return", _context7.sent);
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getAccountListMessage",
    value: function getAccountListMessage() {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.messageDomainService.getEnterpriseAccountListMessage.getAccountListMessage(function (message) {
          var data = message.data;
          var userList = data.userList;
          resolve(userList);
        });
      });
    }
  }, {
    key: "getDeleteAccountMessage",
    value: function getDeleteAccountMessage() {
      var _this4 = this;
      return new Promise(function (resolve) {
        _this4.messageDomainService.getEnterpriseAccountListMessage.getDeleteAccountMessage(function () {
          resolve(true);
        });
      });
    }
  }, {
    key: "getIframeMountMessage",
    value: function getIframeMountMessage() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.messageDomainService.getEnterpriseAccountListMessage.getIframeMountMessage(function () {
          resolve(true);
          _this5.messageDomainService.getEnterpriseAccountListMessage.sendAccountListMessage();
        });
      });
    }
  }]);
  return AccountListApplicationService;
}();
AccountListApplicationService = __decorate([__param(0, IAccountDomainService), __param(1, IMessageDomainService), __metadata("design:paramtypes", [Object, Object])], AccountListApplicationService);

var IBindQQStatus;
(function (IBindQQStatus) {
  IBindQQStatus["BIND_CGI_SUCCESS"] = "BIND_CGI_SUCCESS";
  IBindQQStatus["CHECK_KEY_IS_READY"] = "CHECK_KEY_IS_READY";
  IBindQQStatus["BIND_POLLING_RUNNING"] = "BIND_POLLING_RUNNING";
  IBindQQStatus["BIND_POLLING_FINISH"] = "BIND_POLLING_FINISH";
  IBindQQStatus["BIND_TIMEOUT"] = "BIND_TIMEOUT";
  IBindQQStatus["ERROR"] = "ERROR";
})(IBindQQStatus || (IBindQQStatus = {}));

var QQBindApplication = /*#__PURE__*/function () {
  function QQBindApplication(accountDomainService) {
    _classCallCheck(this, QQBindApplication);
    this.accountDomainService = accountDomainService;
    this.isExpired = false;
  }
  _createClass(QQBindApplication, [{
    key: "getBindingQQAccountInfo",
    value: function getBindingQQAccountInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var bindingQQInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.accountDomainService.accountAggregate.bindingQQInfo();
            case 2:
              bindingQQInfo = _context.sent;
              return _context.abrupt("return", bindingQQInfo);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getStatus",
    value: function getStatus(subscribe) {
      var _this = this;
      this.runBindProcess(subscribe);
      return {
        dispose: function dispose() {
          return _this.dispose();
        }
      };
    }
  }, {
    key: "runBindProcess",
    value: function runBindProcess(subscribe) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$this$accountDo, resData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.accountDomainService.accountAggregate.accountRepository.bindUserInfo();
            case 2:
              _yield$this$accountDo = _context2.sent;
              resData = _yield$this$accountDo.resData;
              if ((resData === null || resData === void 0 ? void 0 : resData.cgicode) === 0 /* RETCODE.SUCCESS */) {
                subscribe(IBindQQStatus.BIND_CGI_SUCCESS);
                this.getKey(subscribe);
              } else {
                subscribe(IBindQQStatus.ERROR, {
                  errBindQQStatus: IBindQQStatus.BIND_CGI_SUCCESS
                });
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.pollingTimer && clearTimeout(this.pollingTimer);
      this.isExpired = true;
    }
  }, {
    key: "getKey",
    value: function getKey(subscribe) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var userIndex, _yield$this$accountDo2, resData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              userIndex = this.accountDomainService.accountAggregate.userInfo.nowUserIndex;
              _context3.next = 3;
              return this.accountDomainService.accountAggregate.accountRepository.getBindWxQrCode(userIndex);
            case 3:
              _yield$this$accountDo2 = _context3.sent;
              resData = _yield$this$accountDo2.resData;
              if (!((resData === null || resData === void 0 ? void 0 : resData.cgicode) === 0 /* RETCODE.SUCCESS */)) {
                _context3.next = 9;
                break;
              }
              subscribe(IBindQQStatus.CHECK_KEY_IS_READY);
              this.runPolling(resData.data.checkKey, subscribe);
              return _context3.abrupt("return");
            case 9:
              subscribe(IBindQQStatus.ERROR, {
                errBindQQStatus: IBindQQStatus.CHECK_KEY_IS_READY
              });
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "runPolling",
    value: function runPolling(checkKey, subscribe) {
      var _this2 = this;
      if (this.isExpired) {
        return;
      }
      this.pollingTimer = setTimeout(function () {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var _yield$this$accountDo3, resData;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.accountDomainService.accountAggregate.accountRepository.getBindProcess(checkKey);
              case 2:
                _yield$this$accountDo3 = _context4.sent;
                resData = _yield$this$accountDo3.resData;
                clearTimeout(this.pollingTimer);
                if (!((resData === null || resData === void 0 ? void 0 : resData.cgicode) === 0 /* RETCODE.SUCCESS */)) {
                  _context4.next = 15;
                  break;
                }
                if (!resData.data.isFinish) {
                  _context4.next = 9;
                  break;
                }
                subscribe(IBindQQStatus.BIND_POLLING_FINISH);
                return _context4.abrupt("return");
              case 9:
                if (!(Number(resData.data.lastUpdateRs) > 15)) {
                  _context4.next = 12;
                  break;
                }
                subscribe(IBindQQStatus.BIND_POLLING_FINISH, {
                  progress: this.getProgress(resData.data.totalNum, resData.data.succNum)
                });
                return _context4.abrupt("return");
              case 12:
                subscribe(IBindQQStatus.BIND_POLLING_RUNNING, {
                  progress: this.getProgress(resData.data.totalNum, resData.data.succNum)
                });
                this.runPolling(checkKey, subscribe);
                return _context4.abrupt("return");
              case 15:
                subscribe(IBindQQStatus.ERROR, {
                  errBindQQStatus: IBindQQStatus.BIND_POLLING_RUNNING
                });
              case 16:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
      }, 1000);
    }
  }, {
    key: "getProgress",
    value: function getProgress(total) {
      var successNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!total) {
        return 1;
      }
      return Math.floor(successNumber / total);
    }
  }]);
  return QQBindApplication;
}();
QQBindApplication = __decorate([__param(0, IAccountDomainService), __metadata("design:paramtypes", [Object])], QQBindApplication);

var QRCodeStatus$1;
(function (QRCodeStatus) {
  // 二维码已就绪且可用
  QRCodeStatus["CODE_IS_READY"] = "CODE_IS_READY";
  // 用户已扫码但尚未登录
  QRCodeStatus["USER_HAS_SCANNED"] = "USER_HAS_SCANNED";
  // 二维码已过期
  QRCodeStatus["CODE_WAS_EXPIRED"] = "CODE_WAS_EXPIRED";
  // 用户已点击确认授权
  QRCodeStatus["USER_HAS_CONFIRMED"] = "USER_HAS_CONFIRMED";
  // 发生了异常
  QRCodeStatus["ERROR"] = "ERROR";
})(QRCodeStatus$1 || (QRCodeStatus$1 = {}));
var latestQRCodeID;
/**
 * 订阅二维码状态
 * @param cb 回调函数，状态变更后会变更多次
 */
function subscribeQRCodeStatus(loginAggregation, checkKey, data) {
  var _this = this;
  latestQRCodeID = checkKey;
  var timerID;
  return function (cb) {
    var updateStatus = function updateStatus() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$loginAggregati, error, resData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(latestQRCodeID !== checkKey)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return loginAggregation.loginRepository.updateWeChatLoginQRCodeStatus(checkKey, data);
            case 4:
              _yield$loginAggregati = _context.sent;
              error = _yield$loginAggregati.error;
              resData = _yield$loginAggregati.resData;
              if (!error) {
                _context.next = 10;
                break;
              }
              cb({
                status: QRCodeStatus$1.ERROR
              });
              return _context.abrupt("return");
            case 10:
              if (!(resData === null || resData === void 0 ? void 0 : resData.data.status.isFinish)) {
                _context.next = 13;
                break;
              }
              cb({
                status: QRCodeStatus$1.USER_HAS_CONFIRMED
              });
              return _context.abrupt("return");
            case 13:
              timerID = setTimeout(updateStatus, 1000);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    updateStatus();
    // 二维码一分钟过期，提前 2 秒将其标记为过期
    setTimeout(function () {
      // 还没有切换新的二维码，掉用过期的回调
      if (latestQRCodeID === checkKey) {
        cb({
          status: QRCodeStatus$1.CODE_WAS_EXPIRED
        });
      }
      clearTimeout(timerID);
    }, 58000);
    // 手动取消订阅
    return function () {
      return clearTimeout(timerID);
    };
  };
}

var WechatBindApplication = /*#__PURE__*/function () {
  function WechatBindApplication(accountDomainService, loginDomainService) {
    _classCallCheck(this, WechatBindApplication);
    this.accountDomainService = accountDomainService;
    this.loginDomainService = loginDomainService;
  }
  _createClass(WechatBindApplication, [{
    key: "getQRCode",
    value: function getQRCode() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var userIndex, response, error, resData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              userIndex = this.accountDomainService.accountAggregate.userInfo.nowUserIndex;
              _context.next = 3;
              return this.accountDomainService.accountAggregate.accountRepository.getBindWxQrCode(userIndex);
            case 3:
              response = _context.sent;
              error = response.error, resData = response.resData;
              if (!error) {
                _context.next = 7;
                break;
              }
              throw error;
            case 7:
              return _context.abrupt("return", this.convertWeChatQRCodeResponse(resData === null || resData === void 0 ? void 0 : resData.data));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "convertWeChatQRCodeResponse",
    value: function convertWeChatQRCodeResponse(responseData) {
      var _ref = responseData !== null && responseData !== void 0 ? responseData : {},
        img = _ref.img,
        qrCodeID = _ref.checkKey;
      if (!img || !qrCodeID) {
        throw Error('获取微信二维码失败');
      }
      return {
        id: qrCodeID,
        image: "data:image/png;base64,".concat(img),
        subscribe: subscribeQRCodeStatus(this.loginDomainService.loginAggregate, qrCodeID)
      };
    }
  }]);
  return WechatBindApplication;
}();
WechatBindApplication = __decorate([__param(0, IAccountDomainService), __param(1, ILoginDomainService), __metadata("design:paramtypes", [Object, Object])], WechatBindApplication);

var BindApplication = /*#__PURE__*/function () {
  function BindApplication(accountDomainService, loginDomainService) {
    _classCallCheck(this, BindApplication);
    this.accountDomainService = accountDomainService;
    this.loginDomainService = loginDomainService;
  }
  _createClass(BindApplication, [{
    key: "qqBind",
    value: function qqBind(subscribe) {
      if (!this.qqBindApplication) {
        this.qqBindApplication = new QQBindApplication(this.accountDomainService);
      }
      return this.qqBindApplication.getStatus(subscribe);
    }
  }, {
    key: "wechatBind",
    value: function wechatBind() {
      this.wechatBindApplication = new WechatBindApplication(this.accountDomainService, this.loginDomainService);
      return this.wechatBindApplication.getQRCode();
    }
  }, {
    key: "getQQBindingInfo",
    value: function getQQBindingInfo() {
      if (!this.qqBindApplication) {
        this.qqBindApplication = new QQBindApplication(this.accountDomainService);
      }
      return this.qqBindApplication.getBindingQQAccountInfo();
    }
  }, {
    key: "getCurrentAccountBindingInfo",
    value: function getCurrentAccountBindingInfo() {
      return this.accountDomainService.accountAggregate.currentLoginAccountBindInfo();
    }
  }]);
  return BindApplication;
}();
BindApplication = __decorate([__param(0, IAccountDomainService), __param(1, ILoginDomainService), __metadata("design:paramtypes", [Object, Object])], BindApplication);

var IQrWechatLoginStatus;
(function (IQrWechatLoginStatus) {
  // 二维码已就绪且可用, 生成二维码base64和checkKey, 开始执行polling
  IQrWechatLoginStatus["CODE_IS_READY"] = "CODE_IS_READY";
  // 用户已扫码但尚未登录，polling进行
  IQrWechatLoginStatus["USER_HAS_SCANNED"] = "USER_HAS_SCANNED";
  // 二维码已过期, polling停止
  IQrWechatLoginStatus["CODE_WAS_EXPIRED"] = "CODE_WAS_EXPIRED";
  // 用户登录成功, polling停止
  IQrWechatLoginStatus["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
  // 发生了异常
  IQrWechatLoginStatus["ERROR"] = "ERROR";
})(IQrWechatLoginStatus || (IQrWechatLoginStatus = {}));
var IWechatLoginCase;
(function (IWechatLoginCase) {
  IWechatLoginCase[IWechatLoginCase["WECHAT_LOGIN_CASE_DEFAULT"] = 0] = "WECHAT_LOGIN_CASE_DEFAULT";
  IWechatLoginCase[IWechatLoginCase["WECHAT_LOGIN_CASE_H5"] = 1] = "WECHAT_LOGIN_CASE_H5";
})(IWechatLoginCase || (IWechatLoginCase = {}));

var EnterPriseWechatLoginApplication = /*#__PURE__*/function () {
  function EnterPriseWechatLoginApplication(loginDomainService) {
    _classCallCheck(this, EnterPriseWechatLoginApplication);
    this.loginDomainService = loginDomainService;
    this.isExpired = false;
  }
  _createClass(EnterPriseWechatLoginApplication, [{
    key: "login",
    value: function login(subscribe) {
      var _this = this;
      this.runLoginProcess(subscribe);
      return {
        dispose: function dispose() {
          return _this.dispose();
        }
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.qrTimer && clearTimeout(this.qrTimer);
      this.pollingTimer && clearTimeout(this.pollingTimer);
      this.isExpired = true;
    }
  }, {
    key: "runLoginProcess",
    value: function runLoginProcess(subscribe) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var checkKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getWechatLoginQRcode(subscribe);
            case 2:
              checkKey = _context.sent;
              if (checkKey) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              this.isExpired = false;
              this.runPolling(checkKey, subscribe);
              this.runQRTimer(subscribe);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getWechatLoginQRcode",
    value: function getWechatLoginQRcode(subscribe) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$this$loginDoma, resData, changeKey, img;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.loginDomainService.loginAggregate.loginRepository.getWeChatLogInQRCodeURI();
            case 2:
              _yield$this$loginDoma = _context2.sent;
              resData = _yield$this$loginDoma.resData;
              if (!((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */)) {
                _context2.next = 11;
                break;
              }
              changeKey = resData.data.checkKey;
              _context2.next = 8;
              return this.getQRcode(changeKey, subscribe);
            case 8:
              img = _context2.sent;
              subscribe(IQrWechatLoginStatus.CODE_IS_READY, {
                qrCodeImage: img
              });
              return _context2.abrupt("return", resData.data.checkKey);
            case 11:
              subscribe(IQrWechatLoginStatus.ERROR, {
                errorQrQQLoginStatus: IQrWechatLoginStatus.CODE_IS_READY
              });
              return _context2.abrupt("return", '');
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getQRcode",
    value: function getQRcode(key, subscribe) {
      return new Promise(function (resolve) {
        QRCode.make("https://".concat(LOCATION_HOST, "/scenario/qr-h5login.html?key=").concat(key)).then(function (url) {
          return resolve(url);
        })["catch"](function () {
          subscribe(IQrWechatLoginStatus.ERROR, {
            errorQrQQLoginStatus: IQrWechatLoginStatus.CODE_IS_READY
          });
        });
      });
    }
  }, {
    key: "runPolling",
    value: function runPolling(changeKey, subscribe) {
      var _this2 = this;
      if (this.isExpired) {
        return;
      }
      this.pollingTimer = setTimeout(function () {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var _a, _b, _yield$this$loginDoma2, resData, _ref, loginScanFlag, login;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.loginDomainService.loginAggregate.loginRepository.updateEnterpriseWeChatLoginQRCodeStatus(changeKey);
              case 2:
                _yield$this$loginDoma2 = _context3.sent;
                resData = _yield$this$loginDoma2.resData;
                if (!((resData === null || resData === void 0 ? void 0 : resData.retcode) !== 0 /* RETCODE.SUCCESS */)) {
                  _context3.next = 9;
                  break;
                }
                subscribe(IQrWechatLoginStatus.ERROR, {
                  errorQrQQLoginStatus: IQrWechatLoginStatus.USER_HAS_SCANNED
                });
                clearTimeout(this.qrTimer);
                clearTimeout(this.pollingTimer);
                return _context3.abrupt("return");
              case 9:
                _ref = (_b = (_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : {}, loginScanFlag = _ref.loginScanFlag, login = _ref.login;
                if (!login) {
                  _context3.next = 15;
                  break;
                }
                subscribe(IQrWechatLoginStatus.LOGIN_SUCCESS, {
                  changeKey: changeKey
                });
                clearTimeout(this.qrTimer);
                clearTimeout(this.pollingTimer);
                return _context3.abrupt("return");
              case 15:
                if (loginScanFlag) {
                  subscribe(IQrWechatLoginStatus.USER_HAS_SCANNED);
                }
                clearTimeout(this.pollingTimer);
                this.runPolling(changeKey, subscribe);
              case 18:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
      }, 1000);
    }
  }, {
    key: "runQRTimer",
    value: function runQRTimer(subscribe) {
      var _this3 = this;
      this.qrTimer = setTimeout(function () {
        subscribe(IQrWechatLoginStatus.CODE_WAS_EXPIRED);
        _this3.isExpired = true;
        clearTimeout(_this3.qrTimer);
      }, 58000);
    }
  }]);
  return EnterPriseWechatLoginApplication;
}();
EnterPriseWechatLoginApplication = __decorate([__param(0, ILoginDomainService), __metadata("design:paramtypes", [Object])], EnterPriseWechatLoginApplication);

var SERVICE_WORKER_MESSAGE_TYPE;
(function (SERVICE_WORKER_MESSAGE_TYPE) {
  SERVICE_WORKER_MESSAGE_TYPE["UPDATE_USER_INDEX"] = "account:update-user-index";
  SERVICE_WORKER_MESSAGE_TYPE["DELETE_USER_INDEX"] = "account:delete-user-index";
  SERVICE_WORKER_MESSAGE_TYPE["SWITCH_USER_INDEX"] = "account:switch-user-index";
})(SERVICE_WORKER_MESSAGE_TYPE || (SERVICE_WORKER_MESSAGE_TYPE = {}));

// qq吊起链接不需要收归cac
// eslint-disable-next-line @tencent/tdoc-standalone/no-use-uri-like-literal
var getPtLoginUrl = function getPtLoginUrl(loginNextTime, url) {
  return "https://xui.ptlogin2.qq.com/cgi-bin/xlogin?theme=4&appid=1600000931&pt_no_auth=1&daid=536&link_target=blank&target=self&hide_close_icon=1&style=20&low_login_enable=".concat(loginNextTime ? 1 : 0, "&low_login_foreced=1&low_login_hour=720&hide_border=1&s_url=").concat(encodeURIComponent(url), "&pt_isdocs=0");
};
// eslint-disable-next-line @tencent/tdoc-standalone/no-use-uri-like-literal
var getOauthLoginUrl = function getOauthLoginUrl(url) {
  return "https://graph.qq.com/oauth2.0/authorize?which=Login&display=pc&response_type=code&theme=10&client_id=101458937&redirect_uri=".concat(encodeURIComponent(url), "&state=state");
};
var qqLoginSuccessUrl = "https://".concat(LOCATION_HOST, "/tim/docs/components/BindQQ.html?type=login");
var getQQLoginSuccessUrl = function getQQLoginSuccessUrl(isJumpFromClient) {
  return qqLoginSuccessUrl + (isJumpFromClient ? '&autojump=1' : '');
};
var JUMP_UIN = 'jumpuin';
var QQ_OAUTH_LOGIN_SUCCESS = 'login qq oauth success';

var QrQQLoginStatus;
(function (QrQQLoginStatus) {
  // domain-service iframe消息已经建立链接 window.addEventListener已经建立
  QrQQLoginStatus["IFRAME_MESSAGE_CONNECTED"] = "IFRAME_MESSAGE_CONNECTED";
  // ptLogin的iframe已经加载完成
  QrQQLoginStatus["IFRAME_DOM_MOUNTED"] = "IFRAME_DOM_MOUNTED";
  // 用户已经点击确认，ptLogin的登录态已经种下
  QrQQLoginStatus["USER_HAS_CONFIRMED"] = "USER_HAS_CONFIRMED";
  // 登录成功，请求user_info接口，将ptLogin的登录态更换成文档登录态，并返回userIndex
  QrQQLoginStatus["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
  // 发生错误
  QrQQLoginStatus["ERROR"] = "ERROR";
})(QrQQLoginStatus || (QrQQLoginStatus = {}));

var QRqqLoginApplicationService = /*#__PURE__*/function () {
  function QRqqLoginApplicationService(loginDomainService, messageDomainService) {
    _classCallCheck(this, QRqqLoginApplicationService);
    this.loginDomainService = loginDomainService;
    this.messageDomainService = messageDomainService;
  }
  _createClass(QRqqLoginApplicationService, [{
    key: "login",
    value: function login(options, subscribe) {
      var _this = this;
      this.runLoginProcess(options, subscribe);
      return {
        dispose: function dispose() {
          return _this.disposeQQLoginIframe();
        }
      };
    }
  }, {
    key: "disposeQQLoginIframe",
    value: function disposeQQLoginIframe() {
      this.messageDomainService.qqMessage.qqLoginMessage.dispose();
    }
  }, {
    key: "loadQQLoginIframe",
    value: function loadQQLoginIframe(options, subscribe) {
      var _a, _b, _c;
      this.messageDomainService.qqMessage.qqLoginMessage.connect();
      this.getLoadQQLoginIframeMessage(subscribe);
      this.messageDomainService.qqMessage.qqLoginMessage.createQQLoginIframe(options.qqPtLoginIframeRenderDom, this.getQQLoginIframeSrc((_a = options === null || options === void 0 ? void 0 : options.useOauth) !== null && _a !== void 0 ? _a : false, (_b = options.isCheckAutoLogin) !== null && _b !== void 0 ? _b : true, (_c = options.isJumpFromQQClient) !== null && _c !== void 0 ? _c : false, options.isJumpFromQQClient ? getQuery(JUMP_UIN) : ''));
    }
  }, {
    key: "runLoginProcess",
    value: function runLoginProcess(options, subscribe) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var loginSuccessMessage;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loadQQLoginIframe(options, subscribe);
              _context.next = 3;
              return this.getQQLoginSuccessMessage(subscribe);
            case 3:
              loginSuccessMessage = _context.sent;
              if (!options.disableUserInfoAutoUpdating) {
                _context.next = 7;
                break;
              }
              subscribe(QrQQLoginStatus.LOGIN_SUCCESS, {});
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return this.checkQQLogin(subscribe, loginSuccessMessage, options.loginApiData);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getQQLoginIframeSrc",
    value: function getQQLoginIframeSrc(useOauth, loginNextTime, isJumpFromClient, jumpUin) {
      // 根据参数决定使用QQ互联登录或PtLogin登录
      var qqLoginIframeSrc = useOauth ? getOauthLoginUrl(getQQLoginSuccessUrl(isJumpFromClient)) : getPtLoginUrl(loginNextTime, getQQLoginSuccessUrl(isJumpFromClient));
      if (jumpUin) {
        return "".concat(qqLoginIframeSrc, "&jumpuin=").concat(jumpUin);
      }
      return qqLoginIframeSrc;
    }
  }, {
    key: "getLoadQQLoginIframeMessage",
    value: function getLoadQQLoginIframeMessage(successCallback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.messageDomainService.qqMessage.qqLoginMessage.getQQIframeMessage(function () {
                successCallback(QrQQLoginStatus.IFRAME_DOM_MOUNTED);
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getQQLoginSuccessMessage",
    value: function getQQLoginSuccessMessage(subscribe) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function (resolve) {
                _this2.messageDomainService.qqMessage.qqLoginMessage.getQQLoginSuccessMessage(function (message) {
                  subscribe(QrQQLoginStatus.USER_HAS_CONFIRMED);
                  // 如果是QQ OAuth登录需要返回code
                  var data = message.data;
                  if (typeof data === 'string' && data.startsWith(QQ_OAUTH_LOGIN_SUCCESS)) {
                    if (data.includes('code=')) {
                      var code = data.slice(data.indexOf('code=') + 5);
                      resolve({
                        success: true,
                        code: code
                      });
                    }
                  }
                  // 如果是PtLogin登录则直接返回boolean值
                  resolve({
                    success: true
                  });
                });
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
    }
  }, {
    key: "checkQQLogin",
    value: function checkQQLogin(subscribe, loginSuccessMessage, data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _a, _b, _c, _d, loginCheckResult, _loginCheckResult, resData;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              loginCheckResult = {};
              if (!loginSuccessMessage.code) {
                _context4.next = 7;
                break;
              }
              _context4.next = 4;
              return this.loginDomainService.loginAggregate.loginRepository.checkQQOAuthLogin(loginSuccessMessage.code, data);
            case 4:
              loginCheckResult = _context4.sent;
              _context4.next = 10;
              break;
            case 7:
              _context4.next = 9;
              return this.loginDomainService.loginAggregate.loginRepository.checkQQLogin();
            case 9:
              loginCheckResult = _context4.sent;
            case 10:
              _loginCheckResult = loginCheckResult, resData = _loginCheckResult.resData;
              if (!(resData === null || resData === void 0 ? void 0 : resData.data.userIndex)) {
                _context4.next = 15;
                break;
              }
              subscribe(QrQQLoginStatus.LOGIN_SUCCESS, {
                userIndex: resData === null || resData === void 0 ? void 0 : resData.data.userIndex
              });
              (_b = (_a = navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.postMessage({
                type: SERVICE_WORKER_MESSAGE_TYPE.SWITCH_USER_INDEX,
                data: {
                  userIndex: resData.data.userIndex,
                  url: location.href
                }
              });
              return _context4.abrupt("return");
            case 15:
              if (!((resData === null || resData === void 0 ? void 0 : resData.cgicode) === 0 /* RETCODE.SUCCESS */)) {
                _context4.next = 19;
                break;
              }
              subscribe(QrQQLoginStatus.LOGIN_SUCCESS);
              (_d = (_c = navigator.serviceWorker) === null || _c === void 0 ? void 0 : _c.controller) === null || _d === void 0 ? void 0 : _d.postMessage({
                type: SERVICE_WORKER_MESSAGE_TYPE.SWITCH_USER_INDEX,
                data: {
                  url: location.href
                }
              });
              return _context4.abrupt("return");
            case 19:
              subscribe(QrQQLoginStatus.ERROR, {
                errorQrQQLoginStatus: QrQQLoginStatus.LOGIN_SUCCESS
              });
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }]);
  return QRqqLoginApplicationService;
}();
QRqqLoginApplicationService = __decorate([__param(0, ILoginDomainService), __param(1, IMessageDomainService), __metadata("design:paramtypes", [Object, Object])], QRqqLoginApplicationService);

var WechatLoginApplication = /*#__PURE__*/function () {
  function WechatLoginApplication(messageDomainService, loginDomainService, accountDomainService) {
    _classCallCheck(this, WechatLoginApplication);
    this.messageDomainService = messageDomainService;
    this.loginDomainService = loginDomainService;
    this.accountDomainService = accountDomainService;
    this.isExpired = false;
  }
  _createClass(WechatLoginApplication, [{
    key: "login",
    value: function login(subscribe, options) {
      var _this = this;
      this.runLoginProcess(subscribe, options);
      return {
        dispose: function dispose() {
          return _this.dispose();
        }
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.qrTimer) {
        clearTimeout(this.qrTimer);
      }
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
      }
      this.isExpired = true;
    }
  }, {
    key: "runLoginProcess",
    value: function runLoginProcess(subscribe, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var checkKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (options === null || options === void 0 ? void 0 : options.useOfficialAccountOrH5) ? this.getWechatLoginQRUrl(subscribe, options) : this.getWechatLoginQRcode(subscribe);
            case 2:
              checkKey = _context.sent;
              if (checkKey) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              this.isExpired = false;
              this.runPolling(checkKey, subscribe, options === null || options === void 0 ? void 0 : options.pollingApiData);
              this.runQRTimer(checkKey, subscribe);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getWechatLoginQRcode",
    value: function getWechatLoginQRcode(subscribe) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$this$loginDoma, resData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.loginDomainService.loginAggregate.loginRepository.getWeChatLogInQRCodeURI();
            case 2:
              _yield$this$loginDoma = _context2.sent;
              resData = _yield$this$loginDoma.resData;
              if (!((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */)) {
                _context2.next = 7;
                break;
              }
              subscribe(IQrWechatLoginStatus.CODE_IS_READY, {
                qrCodeImage: "data:image/png;base64,".concat(resData.data.img),
                checkKey: resData.data.checkKey
              });
              return _context2.abrupt("return", resData.data.checkKey);
            case 7:
              subscribe(IQrWechatLoginStatus.ERROR, {
                errorQrQQLoginStatus: IQrWechatLoginStatus.CODE_IS_READY
              });
              return _context2.abrupt("return", '');
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getWechatLoginQRUrl",
    value: function getWechatLoginQRUrl(subscribe, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$this$loginDoma2, resData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.loginDomainService.loginAggregate.loginRepository.getWeChatLogInQRURI(options === null || options === void 0 ? void 0 : options.wechatLoginCase);
            case 2:
              _yield$this$loginDoma2 = _context3.sent;
              resData = _yield$this$loginDoma2.resData;
              if (!((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */)) {
                _context3.next = 7;
                break;
              }
              subscribe(IQrWechatLoginStatus.CODE_IS_READY, {
                qrCodeUrl: resData.data.url,
                checkKey: resData.data.checkKey
              });
              return _context3.abrupt("return", resData.data.checkKey);
            case 7:
              subscribe(IQrWechatLoginStatus.ERROR, {
                errorQrQQLoginStatus: IQrWechatLoginStatus.CODE_IS_READY
              });
              return _context3.abrupt("return", '');
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "runPolling",
    value: function runPolling(checkKey, subscribe, data) {
      var _this2 = this;
      var nowUserIndex = this.accountDomainService.accountAggregate.userInfo.nowUserIndex;
      if (this.isExpired) {
        return;
      }
      this.pollingTimer = setTimeout(function () {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var _a, _b, _c, _d, _yield$this$loginDoma3, resData, _ref, loginScanFlag, login;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.loginDomainService.loginAggregate.loginRepository.updateWeChatLoginQRCodeStatus(checkKey, data);
              case 2:
                _yield$this$loginDoma3 = _context4.sent;
                resData = _yield$this$loginDoma3.resData;
                if (!((resData === null || resData === void 0 ? void 0 : resData.retcode) !== 0 /* RETCODE.SUCCESS */)) {
                  _context4.next = 10;
                  break;
                }
                // 登录推送信息到其他 tab
                MsgCenter.postMessage({
                  type: ILogoutMessageType.LOGIN,
                  data: nowUserIndex,
                  needCookie: true
                });
                subscribe(IQrWechatLoginStatus.ERROR, {
                  errorQrQQLoginStatus: IQrWechatLoginStatus.USER_HAS_SCANNED,
                  checkKey: checkKey
                });
                clearTimeout(this.qrTimer);
                clearTimeout(this.pollingTimer);
                return _context4.abrupt("return");
              case 10:
                _ref = (_b = (_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : {}, loginScanFlag = _ref.loginScanFlag, login = _ref.login;
                if (!login) {
                  _context4.next = 18;
                  break;
                }
                // 登录推送信息到其他 tab
                MsgCenter.postMessage({
                  type: ILogoutMessageType.LOGIN,
                  data: nowUserIndex,
                  needCookie: true
                });
                subscribe(IQrWechatLoginStatus.LOGIN_SUCCESS, {
                  userIndex: resData.data.userIndex,
                  checkKey: checkKey
                });
                clearTimeout(this.qrTimer);
                clearTimeout(this.pollingTimer);
                (_d = (_c = navigator.serviceWorker) === null || _c === void 0 ? void 0 : _c.controller) === null || _d === void 0 ? void 0 : _d.postMessage({
                  type: SERVICE_WORKER_MESSAGE_TYPE.SWITCH_USER_INDEX,
                  data: {
                    userIndex: resData.data.userIndex,
                    url: location.href
                  }
                });
                return _context4.abrupt("return");
              case 18:
                if (loginScanFlag) {
                  subscribe(IQrWechatLoginStatus.USER_HAS_SCANNED, {
                    checkKey: checkKey
                  });
                }
                clearTimeout(this.pollingTimer);
                this.runPolling(checkKey, subscribe, data);
              case 21:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
      }, 1000);
    }
  }, {
    key: "runQRTimer",
    value: function runQRTimer(checkKey, subscribe) {
      var _this3 = this;
      this.qrTimer = setTimeout(function () {
        subscribe(IQrWechatLoginStatus.CODE_WAS_EXPIRED, {
          checkKey: checkKey
        });
        _this3.isExpired = true;
        clearTimeout(_this3.qrTimer);
      }, 58000);
    }
  }]);
  return WechatLoginApplication;
}();
WechatLoginApplication = __decorate([__param(0, IMessageDomainService), __param(1, ILoginDomainService), __metadata("design:paramtypes", [Object, Object, Object])], WechatLoginApplication);

var encodeHTML = function encodeHTML(url) {
  return url.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
};
var getWeworkIframeSrc = function getWeworkIframeSrc(src) {
  if (LOCATION_HOST === WECOM_DOCS_EDITOR) {
    return "https://".concat(LOCATION_HOST, "/components/feature/WeworkLogin.html?redirect_uri=").concat(encodeURIComponent(src), "&open_id_gray=1&code_gray=1");
  }
  return "https://".concat(LOCATION_HOST, "/scenario/wework-quick-login.html?redirect_uri=").concat(encodeURIComponent(src), "&open_id_gray=1&code_gray=1");
};

var IQrWecomLoginStatus;
(function (IQrWecomLoginStatus) {
  // domain-service iframe消息已经建立链接 window.addEventListener已经建立
  IQrWecomLoginStatus["IFRAME_MESSAGE_CONNECTED"] = "IFRAME_MESSAGE_CONNECTED";
  // 企业微信快速登录的iframe已经加载完成
  IQrWecomLoginStatus["IFRAME_DOM_MOUNTED"] = "IFRAME_DOM_MOUNTED";
  // 用户已经点击确认，企业微信快速登录成功返回code;
  IQrWecomLoginStatus["USER_HAS_CONFIRMED"] = "USER_HAS_CONFIRMED";
  // 成功获取checkKey
  IQrWecomLoginStatus["GOT_CHANGE_KEY"] = "GOT_CHANGE_KEY";
  // 登录成功，企业微信接口调用成功，并返回userIndex
  IQrWecomLoginStatus["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
  // 发生错误
  IQrWecomLoginStatus["ERROR"] = "ERROR";
})(IQrWecomLoginStatus || (IQrWecomLoginStatus = {}));

var WeworkLoginApplicationService = /*#__PURE__*/function () {
  function WeworkLoginApplicationService(messageDomainService) {
    _classCallCheck(this, WeworkLoginApplicationService);
    this.messageDomainService = messageDomainService;
  }
  _createClass(WeworkLoginApplicationService, [{
    key: "login",
    value: function login(options, subscribe) {
      var _this = this;
      this.loadWeworkLoginIframe(options, subscribe);
      this.getWeworkLoginSuccessMessage(subscribe);
      return {
        dispose: function dispose() {
          return _this.dispose();
        }
      };
    }
  }, {
    key: "loadWeworkLoginIframe",
    value: function loadWeworkLoginIframe(options, subscribe) {
      this.messageDomainService.weworkMessage.weworkLoginMessage.connect('enterprise');
      this.getLoadWeworkLoginIframeMessage(subscribe);
      this.messageDomainService.weworkMessage.weworkLoginMessage.createWeworkLoginIframe(options.weworkLoginIframeRenderDom, getWeworkIframeSrc(encodeHTML(options.targetUrl)));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.messageDomainService.weworkMessage.weworkLoginMessage.dispose();
    }
  }, {
    key: "getLoadWeworkLoginIframeMessage",
    value: function getLoadWeworkLoginIframeMessage(successCallback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.messageDomainService.weworkMessage.weworkLoginMessage.getWeworkIframeMessage(function () {
                successCallback(IQrWecomLoginStatus.IFRAME_DOM_MOUNTED);
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getWeworkLoginSuccessMessage",
    value: function getWeworkLoginSuccessMessage(subscribe) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve) {
                _this2.messageDomainService.weworkMessage.weworkLoginMessage.getWeworkLoginSuccessMessage(function (message) {
                  var _a, _b;
                  var data = message.data;
                  if (data.includes('code=')) {
                    subscribe(IQrWecomLoginStatus.LOGIN_SUCCESS, {
                      code: data.slice(data.indexOf('code=') + 5)
                    });
                  } else {
                    subscribe(IQrWecomLoginStatus.LOGIN_SUCCESS);
                  }
                  (_b = (_a = navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.postMessage({
                    type: SERVICE_WORKER_MESSAGE_TYPE.SWITCH_USER_INDEX,
                    data: {
                      url: location.href
                    }
                  });
                  // 登录推送信息到其他 tab
                  MsgCenter.postMessage({
                    type: ILogoutMessageType.LOGIN,
                    data: '',
                    needCookie: true
                  });
                  resolve(data);
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }
  }]);
  return WeworkLoginApplicationService;
}();
WeworkLoginApplicationService = __decorate([__param(0, IMessageDomainService), __metadata("design:paramtypes", [Object])], WeworkLoginApplicationService);

var DCLoginApplicationService = /*#__PURE__*/function () {
  function DCLoginApplicationService(loginDomainService, messageDomainService, accountDomainService) {
    _classCallCheck(this, DCLoginApplicationService);
    this.loginDomainService = loginDomainService;
    this.messageDomainService = messageDomainService;
    this.accountDomainService = accountDomainService;
  }
  // 支持通过参数控制登录方式:ptlogin或QQ互联
  _createClass(DCLoginApplicationService, [{
    key: "qrQQLogin",
    value: function qrQQLogin(options, subscribe) {
      var qqLoginApplicationService = new QRqqLoginApplicationService(this.loginDomainService, this.messageDomainService);
      return qqLoginApplicationService.login(options, subscribe);
    }
    // 支持通过参数控制登录方式: 小程序或公众号或H5
  }, {
    key: "qrWechatLogin",
    value: function qrWechatLogin(subscribe, options) {
      var wechatLoginApplication = new WechatLoginApplication(this.messageDomainService, this.loginDomainService, this.accountDomainService);
      return wechatLoginApplication.login(subscribe, options);
    }
  }, {
    key: "enterpriseQrWechatLogin",
    value: function enterpriseQrWechatLogin(subscribe) {
      var enterpriseWechatLoginApplication = new EnterPriseWechatLoginApplication(this.loginDomainService);
      return enterpriseWechatLoginApplication.login(subscribe);
    }
  }, {
    key: "qrWecomLogin",
    value: function qrWecomLogin(options, subscribe) {
      var weworkLoginApplicationService = new WeworkLoginApplicationService(this.messageDomainService);
      return weworkLoginApplicationService.login(options, subscribe);
    }
  }]);
  return DCLoginApplicationService;
}();
DCLoginApplicationService = __decorate([__param(0, ILoginDomainService), __param(1, IMessageDomainService), __metadata("design:paramtypes", [Object, Object, Object])], DCLoginApplicationService);

// 默认cookie存30天
var DEFAULT_EXPIRE_DAYS = 30 * 24 * 60 * 60 * 1000;
// 一天的毫秒数
var TIMEINTERVAL_OF_DAY = 24 * 60 * 60 * 1000;
// document 属性名
var DOCUMENT_PREPROTY = 'document';
/**
 * ark 目前支持的常用cookie字段集合。
 * 建议不要直接使用setCookie和getCookie
 */
var COMMON_COOKIES_KEYS;
(function (COMMON_COOKIES_KEYS) {
  /**
   * cgi相关 xsrf token
   */
  COMMON_COOKIES_KEYS["xsrf"] = "TOK";
  /**
   * 测试环境相关   测试环境routeId
   */
  COMMON_COOKIES_KEYS["devRouteId"] = "dev_route_id";
  /**
   * 测试环境相关   测试环境登录账号名
   */
  COMMON_COOKIES_KEYS["devOaName"] = "dev_oa_name";
  /**
   * 测试环境相关   测试环境FD
   */
  COMMON_COOKIES_KEYS["fd"] = "fd";
  /**
   * 测试环境相关   env_id 后期epc统计相关字段
   */
  COMMON_COOKIES_KEYS["envId"] = "env_id";
  /**
   * 登录态相关
   * 登录态判断和取当前登录用户信息不要直接用Cookie判断
   * 取UserInfoDomainService的isLogin来判断是否登录
   * uid 取UserInfoDomainService里UserInfo.tinyid
   */
  /**
   * 登录态相关   多登录态SID
   */
  COMMON_COOKIES_KEYS["sid"] = "SID";
  /**
   * 登录态相关   多登录态SIDS
   */
  COMMON_COOKIES_KEYS["sids"] = "SID_S";
  /**
   * 登录态相关   uid
   */
  COMMON_COOKIES_KEYS["uid"] = "uid";
  /**
   * 登录态相关   uid_key
   */
  COMMON_COOKIES_KEYS["uidKey"] = "uid_key";
  /**
   * 登录态相关   uin QQ号
   */
  COMMON_COOKIES_KEYS["uin"] = "uin";
  /**
   * 登录态相关   登录时间
   */
  COMMON_COOKIES_KEYS["loginTime"] = "loginTime";
  /**
   * 登录态相关   是否已登录
   */
  COMMON_COOKIES_KEYS["hasBeenLogin"] = "has_been_login";
  /**
   * 其它   渠道号
   */
  COMMON_COOKIES_KEYS["adtag"] = "adtag";
  /**
   * QQ登录字段
   */
  COMMON_COOKIES_KEYS["plUin"] = "p_luin";
  /**
   * QQ登录字段
   */
  COMMON_COOKIES_KEYS["pUin"] = "p_uin";
  /**
   * QQ登录字段
   */
  COMMON_COOKIES_KEYS["pSkey"] = "p_skey";
  /**
   * QQ登录字段
   */
  COMMON_COOKIES_KEYS["plSkey"] = "p_lskey";
})(COMMON_COOKIES_KEYS || (COMMON_COOKIES_KEYS = {}));
/**
 * object类型为转string
 * @param val
 * @returns
 */
function privateStringify(val) {
  return isObject(val) ? JSON.stringify(val) : val;
}
/**
 * set cookie
 * @param {string} key            [key]
 * @param {any} val               [value]
 * @param {number options} days   [days]
 * @param {string options} path   [path]
 * @param {string options} domain [domain]
 */
function setCookie(key, val, days, path, domain) {
  if (!has(global$1, DOCUMENT_PREPROTY)) {
    // node环境目前简单处理，后续需要mock再处理；
    return;
  }
  var value = encodeURIComponent(privateStringify(val));
  // 浏览器环境，直接操作；
  // 计算保存时长, 默认cookie存30天
  var expireIntervals = DEFAULT_EXPIRE_DAYS;
  if (days) {
    expireIntervals = TIMEINTERVAL_OF_DAY * days;
  }
  // 生成过期时间expire
  var expire = new Date();
  expireIntervals = expireIntervals + expire.getTime();
  expire.setTime(expireIntervals);
  var gmtExpire = expire.toUTCString();
  // 可选参数处理
  var finalPath = path ? path : '/';
  var finalDomain = domain ? "domain=".concat(domain, ";") : '';
  // set cookie
  document.cookie = "".concat(key, "=").concat(value, ";expires=").concat(gmtExpire, ";path=").concat(finalPath, ";").concat(finalDomain);
}
/**
 * del cookie
 * @param  {string} key    [key]
 * @param  {string} path   [path]
 * @param  {string} domain [domain]
 */
function delCookie(key, path, domain) {
  if (!has(global$1, DOCUMENT_PREPROTY)) {
    // node环境目前简单处理，后续需要mock再处理；
    return;
  }
  // 可选参数处理
  var finalPath = path ? path : '/';
  var finalDomain = domain ? "domain=".concat(domain, ";") : '';
  // 生成过期时间expire
  var expire = new Date(0);
  var gmtExpire = expire.toUTCString();
  // del cookie
  document.cookie = "".concat(key, "=;expires=").concat(gmtExpire, ";path=").concat(finalPath, ";").concat(finalDomain);
}
/**
 * get cookie
 * @param  {string} key [key]
 * @return {string}     [cookie value]
 */
function getCookie(key) {
  if (!has(global$1, DOCUMENT_PREPROTY)) {
    // node环境目前简单处理，后续需要mock再处理；
    return null;
  }
  var reg = new RegExp("(?:^|;+|\\s+)".concat(key, "=([^;]*)"));
  var result = document.cookie.match(reg);
  return (!result ? null : result[1]) || null;
}
/**
 * 获取 cookie 中的 uid
 *  默认为 null ，而不是空字符串
 */
function getCookieUid() {
  return getCookie('uid') || null;
}

// hash分隔符
var HASH_SYMBOL = '#';
// search分隔符
var SEARCH_SYMBOL = '?';
// query分隔符
var QUERY_SYMBOL = '&';
/**
 * 内部方法： 处理不带hash url下删除参数的case,
 * @param url
 * @param params
 * @returns
 */
function removeURLParametersWithoutHash(url, params) {
  var _a;
  var urlParts = url.split(SEARCH_SYMBOL);
  var querys = (_a = urlParts[1]) === null || _a === void 0 ? void 0 : _a.split(QUERY_SYMBOL);
  if (!querys) return url;
  var querysAfterRemoved = querys;
  // 遍历querys，是否存在param， 这里全找了遍，避免入url上有重复params或paramValues里有重复params
  params.forEach(function (param) {
    querys.forEach(function (queryParam) {
      // 找到一处，删一处，同一个key出现多次，全清.   此处改为 index === 0, 全匹配
      if (queryParam.startsWith("".concat(param, "="))) {
        var index = querysAfterRemoved.indexOf(queryParam);
        querysAfterRemoved.splice(index, 1);
      }
    });
  });
  // 删光了，直接返回没有search部分
  if (querysAfterRemoved.length === 0) {
    return urlParts[0];
  }
  // 还有参数，重组url
  urlParts[1] = querysAfterRemoved.join(QUERY_SYMBOL);
  return urlParts.join(SEARCH_SYMBOL);
}
/**
 * 检查带search的url上是否有param，如果有更新，没有就添加
 * @param url // 内部方法，一定是有search的情况
 * @param param
 * @param value
 * @returns
 */
function checkExistParamAddOrUpdate(url, param, value) {
  var urlParts = url.split(SEARCH_SYMBOL);
  var querys = urlParts[1].split(QUERY_SYMBOL);
  // 默认param不存在
  var notParam = true;
  // 存放querys的map，用map为了去重
  var querysMap = new Map();
  querys.forEach(function (query) {
    var paramValue = query.split('=');
    querysMap.set(paramValue[0], paramValue[1]);
  });
  // 打有没有当前要add的param，有直接更新
  querys.some(function (query) {
    if (query.startsWith("".concat(param, "="))) {
      querysMap.set(param, value);
      notParam = false;
    }
  });
  // 没有直接拼
  if (notParam) {
    querysMap.set(param, value);
  }
  // 拼新url并返回
  var tempQueryKeys = [];
  querysMap.forEach(function (val, key) {
    var query = "".concat(key, "=").concat(val);
    tempQueryKeys.push(query);
  });
  urlParts[1] = tempQueryKeys.join(QUERY_SYMBOL);
  return urlParts.join(SEARCH_SYMBOL);
}
/**
 * 内部方法： 处理不带hash url下删除参数的case,
 * @param url
 * @param paramValues
 * @returns
 */
function addURLParametersWithoutHash(url, paramValues) {
  // 有search 逐个param处理query
  if (url.includes(SEARCH_SYMBOL)) {
    var tempUrl_1 = url;
    Object.keys(paramValues).map(function (param) {
      tempUrl_1 = checkExistParamAddOrUpdate(tempUrl_1, param, paramValues[param]);
    });
    return tempUrl_1;
  }
  // 没有search， 直接拼上即可
  var search = Object.keys(paramValues).map(function (param) {
    return "".concat(param, "=").concat(paramValues[param]);
  }).join(QUERY_SYMBOL);
  return "".concat(url, "?").concat(search);
}
/**
 * 删除url上指定参数
 * @param url 要处理的url
 * @param params 可变参数, 多个params可并排写,  或直接传数组进来
 * @returns string
 */
function removeURLParameters(url) {
  var params = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    params[_i - 1] = arguments[_i];
  }
  var urlParts = url.split(SEARCH_SYMBOL);
  // 没有search部分直接返回
  if (urlParts.length < 2 || params.length === 0) {
    return url;
  }
  // 有hash的情况下，先把hash给保存下来，处理完非hash部分再给拼回去
  if (url.includes(HASH_SYMBOL)) {
    var hashParts = url.split(HASH_SYMBOL);
    hashParts[0] = removeURLParametersWithoutHash(hashParts[0], params);
    return hashParts.join(HASH_SYMBOL);
  }
  // 处理非hash case
  return removeURLParametersWithoutHash(url, params);
}
/**
 * 为给定url 添加 或 更新 一组参数
 * 拼参数的时候会按参数字典序排序
 * @param url
 * @param paramValues<string, string | number>的键值对
 * @returns 拼好的url
 */
function addURLParameters(url, paramValues) {
  if (Object.keys(paramValues).length === 0) {
    return url;
  }
  // 有hash的情况下，先把hash给保存下来，处理完非hash部分再给拼回去
  if (url.includes(HASH_SYMBOL)) {
    var urlParts = url.split(HASH_SYMBOL);
    urlParts[0] = addURLParametersWithoutHash(urlParts[0], paramValues);
    return urlParts.join(HASH_SYMBOL);
  }
  // 处理非hash case
  return addURLParametersWithoutHash(url, paramValues);
}

var ENTERPRISE_HOME_PAGE = WECOM_HOME_PAGE;
var AUTO_SHOW_LOGIN = 'autoshowlogin';
var TIME_STAMP = '_t';
var HandleJumpApplicationService = /*#__PURE__*/function () {
  function HandleJumpApplicationService(accountDomainService) {
    _classCallCheck(this, HandleJumpApplicationService);
    this.accountDomainService = accountDomainService;
  }
  _createClass(HandleJumpApplicationService, [{
    key: "loginSuccessJumpUrl",
    value: function loginSuccessJumpUrl(successJumpUrl, isJumpEnterpriseHome, code, jumpOptions) {
      var nowUserIndex = this.accountDomainService.accountAggregate.userInfo.nowUserIndex;
      if (isJumpEnterpriseHome) {
        var redirectUrl = window.btoa(ENTERPRISE_HOME_PAGE).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        // 企微登录态校验接口
        var toJumpToBLoginPageUrl = "".concat(TOB_LOGIN_PAGE_URL, "?product=2&from=30&code=").concat(code, "&redirect_url=").concat(redirectUrl);
        tencentDocOpenUrlForAll({
          replace: jumpOptions === null || jumpOptions === void 0 ? void 0 : jumpOptions.replace,
          // 是否打开新tab由外部传入，默认当前页刷新
          url: toJumpToBLoginPageUrl
        });
        return;
      }
      var theUrl = addURLParameters(removeURLParameters(successJumpUrl, AUTO_SHOW_LOGIN, 'u', 'jumpuin'), _defineProperty({}, TIME_STAMP, Date.now()));
      // 登录推送信息到其他 tab
      MsgCenter.postMessage({
        type: ILogoutMessageType.LOGIN,
        data: nowUserIndex,
        needCookie: true
      });
      tencentDocOpenUrlForAll({
        replace: true,
        url: theUrl
      });
    }
  }, {
    key: "logoutSuccessJumpUrl",
    value: function logoutSuccessJumpUrl() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var removeUserIndexUrl, accountList, uid, filterAccount, account, _newUrl, newUrl;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 多 Tab 多账号身份方案降级单账号灰度开关
              removeUserIndexUrl = removeURLParameters(window.location.href, 'u');
              _context.next = 3;
              return this.accountDomainService.accountAggregate.accountListEntity.getAccountList();
            case 3:
              accountList = _context.sent;
              uid = getCookieUid();
              filterAccount = accountList.find(function (item) {
                return item.uid !== uid;
              });
              account = filterAccount; // 列表有账户，退出当前账号并选最近登录一个账户登录，后端接口已按 login_time 排序
              if (!(account === null || account === void 0 ? void 0 : account.userIndex)) {
                _context.next = 13;
                break;
              }
              _context.next = 10;
              return this.accountDomainService.accountAggregate.accountListEntity.changeSign(account.userIndex);
            case 10:
              _newUrl = addURLParameters(removeURLParameters(removeUserIndexUrl, 'u'), {
                u: account.userIndex
              });
              tencentDocOpenUrlForAll({
                replace: true,
                url: _newUrl
              });
              return _context.abrupt("return");
            case 13:
              // 列表无账户，退出当前账号并返回列表页（兜底逻辑）
              newUrl = addURLParameters(removeURLParameters(removeUserIndexUrl, 'needShowTips'), {
                needShowTips: 1
              });
              tencentDocOpenUrlForAll({
                replace: true,
                url: newUrl,
                noUserIndex: true
              });
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return HandleJumpApplicationService;
}();
HandleJumpApplicationService = __decorate([__param(0, IAccountDomainService), __metadata("design:paramtypes", [Object])], HandleJumpApplicationService);

var isPCMode = ua.isPC || ua.isIPad && !(ua.isMiniProgram || ua.isTencentDocsApp || ua.isWeChat || ua.isQQ || ua.isTim || ua.isWxWork);
var LoginApplicationService = /*#__PURE__*/function () {
  function LoginApplicationService(loginDomainService) {
    _classCallCheck(this, LoginApplicationService);
    this.loginDomainService = loginDomainService;
  }
  _createClass(LoginApplicationService, [{
    key: "login",
    value: function login(targetUrl, reLoginPC, loginWx) {
      // TODO: 这里面带环境token方案明确后面会优化，具体实现逻辑应该放置domain中
      if (document.location.pathname.indexOf('/desktop') > -1) {
        this.desktopLogin(targetUrl, reLoginPC);
        return;
      }
      this.docLogin(targetUrl, reLoginPC, loginWx);
    }
  }, {
    key: "docLogin",
    value: function docLogin(targetUrl, reLoginPC, loginWx) {
      var loginAggregate = this.loginDomainService.loginAggregate;
      if (ua.isMiniProgram) {
        loginAggregate.loginDocsInMiniProgram(targetUrl);
        return;
      }
      if (ua.isWeChat) {
        loginWx();
        return;
      }
      if (ua.isWxWork) {
        loginAggregate.loginDocsInWework(targetUrl);
        return;
      }
      if (ua.isTimOrQQ) {
        loginAggregate.timOrQQH5Login();
      }
      if (isPCMode) {
        // 在iPad上，如果不在特定端里面，则可以走pc登录
        reLoginPC();
        return;
      }
      loginAggregate.jumpToLoginInCommonView(targetUrl);
    }
  }, {
    key: "desktopLogin",
    value: function desktopLogin(targetUrl, reLoginPC) {
      var loginAggregate = this.loginDomainService.loginAggregate;
      if (ua.isMiniProgram) {
        loginAggregate.reloadMiniProgramForDesktop();
        return;
      }
      if (ua.isWeChat) {
        loginAggregate.jumpToLoginInWechatWebview(targetUrl);
        return;
      }
      if (ua.isWxWork) {
        loginAggregate.jumpToLoginInWeworkWebview(targetUrl);
        return;
      }
      if (isPCMode) {
        // 在iPad上，如果不在特定端里面，则可以走pc登录
        reLoginPC();
        return;
      }
      loginAggregate.jumpToLoginInCommonView(targetUrl);
    }
  }]);
  return LoginApplicationService;
}();
LoginApplicationService = __decorate([__param(0, ILoginDomainService), __metadata("design:paramtypes", [Object])], LoginApplicationService);

/**
 * @deprecated 不要在这里维护账号类型，应该使用后台协议中定义的枚举值
 * import type { docx } from '@tencent/tdocs-shared-proto/lib/3rd/oidb/user/data/online_docs_user_data';
 * export type ACCOUNT_TYPE = docx.backend.common.proto.third.oidb.user.data.UID_SOURCE;
 * 登录类型
 */
var ACCOUNT_TYPE;
(function (ACCOUNT_TYPE) {
  ACCOUNT_TYPE[ACCOUNT_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
  ACCOUNT_TYPE[ACCOUNT_TYPE["QQ"] = 1] = "QQ";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WX"] = 2] = "WX";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WORK"] = 3] = "WORK";
  ACCOUNT_TYPE[ACCOUNT_TYPE["EMAIL"] = 4] = "EMAIL";
  ACCOUNT_TYPE[ACCOUNT_TYPE["PHONE"] = 8] = "PHONE";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WORK_COMBINATION"] = 9] = "WORK_COMBINATION";
  ACCOUNT_TYPE[ACCOUNT_TYPE["TOWER"] = 10] = "TOWER";
  ACCOUNT_TYPE[ACCOUNT_TYPE["ROBOT"] = 11] = "ROBOT";
  ACCOUNT_TYPE[ACCOUNT_TYPE["QFYF"] = 12] = "QFYF";
  ACCOUNT_TYPE[ACCOUNT_TYPE["OPEN"] = 13] = "OPEN";
  ACCOUNT_TYPE[ACCOUNT_TYPE["MEETING"] = 14] = "MEETING";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));
// b端登录类型
var LOGINTYPE;
(function (LOGINTYPE) {
  LOGINTYPE[LOGINTYPE["UNKNOWN"] = 0] = "UNKNOWN";
  /**
   * 微信登录
   **/
  LOGINTYPE[LOGINTYPE["WECHAT"] = 4] = "WECHAT";
  /**
   * 企业微信登录
   **/
  LOGINTYPE[LOGINTYPE["WEWORK"] = 3] = "WEWORK";
})(LOGINTYPE || (LOGINTYPE = {}));

// TODO: 这里应该放置到domain中去，这里cookie的key应该新增到utils包中去。
var clearCookieForQQ = function clearCookieForQQ() {
  delCookie('p_uin', '/', TOC_COOKIE_DOMAIN);
  delCookie('p_skey', '/', TOC_COOKIE_DOMAIN);
  delCookie('p_luin', '/', TOC_COOKIE_DOMAIN);
  delCookie('p_lskey', '/', TOC_COOKIE_DOMAIN);
  delCookie('p_uin', '/', PARENT_TOC_COOKIE_DOMAIN);
  delCookie('p_skey', '/', PARENT_TOC_COOKIE_DOMAIN);
  delCookie('p_luin', '/', PARENT_TOC_COOKIE_DOMAIN);
  delCookie('p_lskey', '/', PARENT_TOC_COOKIE_DOMAIN);
  delCookie('txdoc_pwd_token', '/', TOC_COOKIE_DOMAIN);
};
var clearAllCookie = function clearAllCookie() {
  delCookie('utype', '/', TOB_COOKIE_DOMAIN);
  delCookie('uid', '/', TOB_COOKIE_DOMAIN);
  delCookie('uid', '/', EXACTLY_PARENT_TOC_COOKIE_DOMAIN);
  delCookie('uid_key', '/', TOB_COOKIE_DOMAIN);
  // for polling
  delCookie('login_client', '/', TOB_COOKIE_DOMAIN);
  delCookie('CheckKey', '/', TOB_COOKIE_DOMAIN);
  // for XSRF
  delCookie('TOK', '/', TOB_COOKIE_DOMAIN);
  // for collaboration session
  delCookie('ES2', '/', TOB_COOKIE_DOMAIN);
  delCookie('loginTime', '/', TOB_COOKIE_DOMAIN);
  // 企微cookie
  delCookie('wedrive_uin', '/', TOC_COOKIE_DOMAIN);
  delCookie('wedrive_sids', '/', TOC_COOKIE_DOMAIN);
  delCookie('wedrive_sid', '/', TOC_COOKIE_DOMAIN);
  delCookie('wedrive_skey', '/', TOC_COOKIE_DOMAIN);
  delCookie('wedrive_ticket', '/', TOC_COOKIE_DOMAIN);
  delCookie('wedrive_uin', '/', PARENT_TOB_COOKIE_DOMAIN);
  delCookie('wedrive_sids', '/', PARENT_TOB_COOKIE_DOMAIN);
  delCookie('wedrive_sid', '/', PARENT_TOB_COOKIE_DOMAIN);
  delCookie('wedrive_skey', '/', PARENT_TOB_COOKIE_DOMAIN);
  delCookie('wedrive_ticket', '/', PARENT_TOB_COOKIE_DOMAIN);
  delCookie('wedrive_uin', '/', TOB_COOKIE_DOMAIN);
  delCookie('wedrive_sids', '/', TOB_COOKIE_DOMAIN);
  delCookie('wedrive_sid', '/', TOB_COOKIE_DOMAIN);
  delCookie('wedrive_skey', '/', TOB_COOKIE_DOMAIN);
  delCookie('wedrive_ticket', '/', TOB_COOKIE_DOMAIN);
  // 老微盘cookie
  delCookie('tdoc_vid', '/', TOC_COOKIE_DOMAIN);
  delCookie('tdoc_sid', '/', TOC_COOKIE_DOMAIN);
  delCookie('tdoc_skey', '/', TOC_COOKIE_DOMAIN);
  delCookie('tdoc_vid', '/', PARENT_TOB_COOKIE_DOMAIN);
  delCookie('tdoc_sid', '/', PARENT_TOB_COOKIE_DOMAIN);
  delCookie('tdoc_skey', '/', PARENT_TOB_COOKIE_DOMAIN);
  delCookie('tdoc_vid', '/', TOB_COOKIE_DOMAIN);
  delCookie('tdoc_sid', '/', TOB_COOKIE_DOMAIN);
  delCookie('tdoc_skey', '/', TOB_COOKIE_DOMAIN);
  // b端openid登录态
  delCookie('wedoc_openid', '/', TOB_COOKIE_DOMAIN);
  delCookie('wedoc_skey', '/', TOB_COOKIE_DOMAIN);
  delCookie('wedoc_ticket', '/', TOB_COOKIE_DOMAIN);
  delCookie('wedoc_sid', '/', TOB_COOKIE_DOMAIN);
  delCookie('tdoc_uid', '/', TOB_COOKIE_DOMAIN);
  delCookie('tdoc_skey', '/', TOB_COOKIE_DOMAIN);
};

var LogoutApplicationService = /*#__PURE__*/function () {
  function LogoutApplicationService(accountDomainService) {
    _classCallCheck(this, LogoutApplicationService);
    this.accountDomainService = accountDomainService;
  }
  _createClass(LogoutApplicationService, [{
    key: "logout",
    value: function logout(u) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var loginType;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loginType = this.accountDomainService.accountAggregate.userInfo.loginType;
              if (!(loginType === ACCOUNT_TYPE.WORK)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", this.logoutForEnterpriseAccount());
            case 3:
              return _context.abrupt("return", this.logoutForPersonAccount(u));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getLogoutMessage",
    value: function getLogoutMessage(callback) {
      MsgCenter.setCallback(function () {
        callback();
      });
    }
  }, {
    key: "logoutForEnterpriseAccount",
    value: function logoutForEnterpriseAccount() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _a, _b, _this$accountDomainSe, tinyId, nowUserIndex, _yield$this$accountDo, resData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$accountDomainSe = this.accountDomainService.accountAggregate.userInfo, tinyId = _this$accountDomainSe.tinyId, nowUserIndex = _this$accountDomainSe.nowUserIndex;
              _context2.next = 3;
              return this.accountDomainService.accountAggregate.accountRepository.wecomLogoutForCDomain(tinyId);
            case 3:
              _yield$this$accountDo = _context2.sent;
              resData = _yield$this$accountDo.resData;
              if (!((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */)) {
                _context2.next = 9;
                break;
              }
              MsgCenter.postMessage({
                type: ILogoutMessageType.LOGOUT,
                data: nowUserIndex,
                needCookie: true
              });
              (_b = (_a = navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.postMessage({
                type: SERVICE_WORKER_MESSAGE_TYPE.DELETE_USER_INDEX,
                data: {
                  userIndex: nowUserIndex
                }
              });
              return _context2.abrupt("return", true);
            case 9:
              return _context2.abrupt("return", false);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "logoutForPersonAccount",
    value: function logoutForPersonAccount(u) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _a, _b, userIndex, _yield$this$accountDo2, resData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              userIndex = this.accountDomainService.accountAggregate.userInfo.nowUserIndex;
              _context3.next = 3;
              return this.accountDomainService.accountAggregate.accountRepository.logout(u);
            case 3:
              _yield$this$accountDo2 = _context3.sent;
              resData = _yield$this$accountDo2.resData;
              if (!((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */)) {
                _context3.next = 10;
                break;
              }
              MsgCenter.postMessage({
                type: ILogoutMessageType.LOGOUT,
                data: userIndex,
                needCookie: true
              });
              (_b = (_a = navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.postMessage({
                type: SERVICE_WORKER_MESSAGE_TYPE.DELETE_USER_INDEX,
                data: {
                  userIndex: userIndex
                }
              });
              clearCookieForQQ();
              return _context3.abrupt("return", true);
            case 10:
              return _context3.abrupt("return", false);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }]);
  return LogoutApplicationService;
}();
LogoutApplicationService = __decorate([__param(0, IAccountDomainService), __metadata("design:paramtypes", [Object])], LogoutApplicationService);

var getXsrfToken = function getXsrfToken() {
  return getCookie('TOK');
};
function sleep(time) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (res) {
            setTimeout(res, time);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
var checkDomain = function checkDomain(url) {
  return /^(https?:)?\/\/(\w*\.)*(docs\.qq\.com|txdocs\.qq\.com|doc\.weixin\.qq\.com)($|\/|\\|\?)/i.test(decodeURIComponent(url));
};

/**
 * 用户是否可访问该文档
 */
var IPermissionLevel;
(function (IPermissionLevel) {
  IPermissionLevel[IPermissionLevel["CAN_NOT_VIEW"] = 0] = "CAN_NOT_VIEW";
  IPermissionLevel[IPermissionLevel["CAN_VIEW"] = 1] = "CAN_VIEW";
})(IPermissionLevel || (IPermissionLevel = {}));
/**
 * 登录类型
 */
var LoginType;
(function (LoginType) {
  LoginType["QQ"] = "qq";
  LoginType["WX"] = "wx";
  LoginType["WX_WORK"] = "wx-work";
  LoginType["WW"] = "ww";
  LoginType["QFYF"] = "qfyf";
})(LoginType || (LoginType = {}));

var SwitchAccountApplicationService = /*#__PURE__*/function () {
  function SwitchAccountApplicationService(accountDomainService, messageDomainService) {
    _classCallCheck(this, SwitchAccountApplicationService);
    this.accountDomainService = accountDomainService;
    this.messageDomainService = messageDomainService;
    this.accountListApplicationService = new AccountListApplicationService(accountDomainService, messageDomainService);
  }
  _createClass(SwitchAccountApplicationService, [{
    key: "switchAccount",
    value: function switchAccount(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var accountType, userIndex;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              accountType = account.accountType, userIndex = account.userIndex; // 两个tab用不同账号打开，在其中一个 tab 切换账号，另一个 tab 收到切换账号通知，防止被退出账号携带无效u发起请求
              MsgCenter.postMessage({
                type: ILogoutMessageType.SWITCH,
                data: userIndex,
                needCookie: true
              });
              // 如果 B 账号是在 C 端列表页列表页或者 C 端模板页
              // 则跳转到 B 端对应列表页
              // B账号↓
              if (!(accountType === LoginType.WW &&
              // C 端列表页 -> B 端列表页
              document.location.pathname.includes('/desktop'))) {
                _context.next = 5;
                break;
              }
              // 列表页切 B 账号，跳转新 tab 页 B 端列表页
              tencentDocOpenUrlForAll({
                url: WECOM_HOME_PAGE
              });
              return _context.abrupt("return");
            case 5:
              if (!(accountType === LoginType.WW &&
              // C 端模板页 -> B 端列表页，跳转新 tab 页 B 端列表页
              document.location.pathname.includes('/mall'))) {
                _context.next = 8;
                break;
              }
              tencentDocOpenUrlForAll({
                url: WECOM_HOME_PAGE,
                replace: true
              });
              return _context.abrupt("return");
            case 8:
              if (!(accountType === LoginType.WW &&
              // C 端简历页 -> B 端列表页，跳转新 tab 页 B 端列表页
              document.location.pathname.includes('/resume'))) {
                _context.next = 11;
                break;
              }
              tencentDocOpenUrlForAll({
                url: WECOM_HOME_PAGE,
                replace: true
              });
              return _context.abrupt("return");
            case 11:
              // 在 change-sig 之前做一次前端 cookie 清除
              // 因为 change-sig 后是要种 QQ 票
              // 当然 change-sig 也会帮忙做一次清除
              clearCookieForQQ();
              // C 端更新登录态，B 端不需要，B 端走上面逻辑去 B 域登录
              // 切换账号调用 /session/api/multiacc/change-sig 更新登录态
              _context.next = 14;
              return this.accountListApplicationService.changeSign(account);
            case 14:
              // C 账号↓
              this.switchFetchAccount(userIndex);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "switchFetchAccount",
    value: function switchFetchAccount(userIndex) {
      var _a, _b;
      (_b = (_a = navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.postMessage({
        type: SERVICE_WORKER_MESSAGE_TYPE.SWITCH_USER_INDEX,
        data: {
          userIndex: userIndex,
          url: location.href
        }
      });
      tencentDocOpenUrlForAll({
        url: this.getNewJumpUrl(userIndex),
        replace: true,
        noUserIndex: true
      });
    }
  }, {
    key: "switchEnterpriseAccount",
    value: function switchEnterpriseAccount(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        var cookie, flag;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cookie = account.cookie;
              if (cookie) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", false);
            case 3:
              this.messageDomainService.switchEnterpriseAccountMessage.connect();
              this.getIframeMountMessage(cookie);
              this.messageDomainService.switchEnterpriseAccountMessage.createSwitchEnterpriseAccount(function () {
                _this.messageDomainService.switchEnterpriseAccountMessage.sendSwitchAccountMessage(cookie);
              });
              _context2.next = 8;
              return this.getSwitchAccountMessage();
            case 8:
              flag = _context2.sent;
              if (flag) {
                _context2.next = 11;
                break;
              }
              return _context2.abrupt("return", false);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getNewJumpUrl",
    value: function getNewJumpUrl(userIndex) {
      var _location = location,
        pathname = _location.pathname,
        hostname = _location.hostname;
      // 带回跳地址则跳回跳地址，如切换中间页切换账号情况
      var newJumpUrl = "https://".concat(hostname).concat(pathname);
      // 检查回跳地址是否合法
      if (checkDomain(getQuery('success_jump_url'))) {
        newJumpUrl = decodeURIComponent(getQuery('success_jump_url')) || "https://".concat(hostname).concat(pathname);
        // 去除回跳地址上的 u 参数
        newJumpUrl = removeURLParameters(newJumpUrl.replace(/&$/gi, ''), 'u');
      }
      var _location2 = location,
        search = _location2.search;
      // 删除 url 上冗余参数
      search = removeURLParameters(search.replace(/&$/gi, ''), 'hst');
      search = removeURLParameters(search.replace(/&$/gi, ''), 'success_jump_url');
      search = removeURLParameters(search.replace(/&$/gi, ''), 'show_type');
      if (search === '' && userIndex) {
        return "".concat(newJumpUrl, "?u=").concat(userIndex);
      }
      if (search === '') {
        return "".concat(newJumpUrl);
      }
      // 去除旧的 u 参数
      var url = search.replace(/(&)*u=(\w+)(\/|\?|#|&|$)/, '');
      // 添加跳转的新 u 参数
      if (userIndex) {
        return "".concat(newJumpUrl).concat(url, "&u=").concat(userIndex);
      }
      return "".concat(newJumpUrl).concat(url);
    }
  }, {
    key: "getIframeMountMessage",
    value: function getIframeMountMessage(cookie) {
      var _this2 = this;
      return new Promise(function (resolve) {
        _this2.messageDomainService.switchEnterpriseAccountMessage.getIframeMountMessage(function () {
          resolve(true);
          _this2.messageDomainService.switchEnterpriseAccountMessage.sendSwitchAccountMessage(cookie);
        });
      });
    }
  }, {
    key: "getSwitchAccountMessage",
    value: function getSwitchAccountMessage() {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.messageDomainService.switchEnterpriseAccountMessage.getSwitchAccountMessage(function () {
          resolve(true);
        });
      });
    }
  }]);
  return SwitchAccountApplicationService;
}();
SwitchAccountApplicationService = __decorate([__param(0, IAccountDomainService), __param(1, IMessageDomainService), __metadata("design:paramtypes", [Object, Object])], SwitchAccountApplicationService);

var translate$2 = function translate(originalRecord, dict) {
  if (Array.isArray(originalRecord)) {
    return originalRecord.map(function (singleOriginalRecord) {
      return translate(singleOriginalRecord, dict);
    });
  }
  if (!originalRecord) return originalRecord;
  var outputRecord = {};
  for (var _i = 0, _Object$keys = Object.keys(originalRecord); _i < _Object$keys.length; _i++) {
    var sourceWord = _Object$keys[_i];
    var outputWordName = dict.words.includes(sourceWord) ? dict.raw[sourceWord] : sourceWord;
    outputRecord[outputWordName] = originalRecord[sourceWord];
  }
  return outputRecord;
};
// eslint-disable-next-line max-len
var createTranslator = function createTranslator(dict) {
  return function (originalRecord) {
    return translate$2(originalRecord, dict);
  };
};

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var translate$1 = createTranslator(dict);
var AccountApplicationService = /*#__PURE__*/function (_Disposable) {
  _inherits(AccountApplicationService, _Disposable);
  var _super = _createSuper$1(AccountApplicationService);
  function AccountApplicationService(accountDomainService, loginDomainService, messageDomainService) {
    var _this;
    _classCallCheck(this, AccountApplicationService);
    _this = _super.call(this);
    _this.accountDomainService = accountDomainService;
    _this.loginDomainService = loginDomainService;
    _this.messageDomainService = messageDomainService;
    // 创建账号领域
    _this.accountApplicationOfflineService = new AccountApplicationOfflineService();
    var basicClientVars = globalThis === null || globalThis === void 0 ? void 0 : globalThis.basicClientVars;
    _this.isInitFinish = _this.accountDomainService.createPersonalEnvAccountAggregateByBasicClientVars(basicClientVars === null || basicClientVars === void 0 ? void 0 : basicClientVars.userInfo);
    var tinyId = _this.accountDomainService.accountAggregate.userInfo.tinyId;
    // 创建登录领域
    _this.loginDomainService.createLoginAggregate(tinyId);
    _this.initDomainService();
    _this.accountListApplicationService = new AccountListApplicationService(accountDomainService, messageDomainService);
    _this.dcLoginApplicationService = new DCLoginApplicationService(loginDomainService, messageDomainService, accountDomainService);
    return _this;
  }
  // 更新二次密码相关信息
  _createClass(AccountApplicationService, [{
    key: "updatePasswordsSettings",
    value: function updatePasswordsSettings() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var accountAggregate;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              accountAggregate = this.accountDomainService.accountAggregate;
              _context.next = 3;
              return accountAggregate.passwordEntity.updatePwdTips();
            case 3:
              return _context.abrupt("return", {
                enabled: accountAggregate.passwordEntity.isHasPassword,
                phoneNumber: accountAggregate.passwordEntity.phone
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    // 通过拉 vip 信息的接口更新 vip 信息
  }, {
    key: "updateVipInfo",
    value: function updateVipInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$accountDomainSe, vipInfo, userInfo;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getUserVipInfo();
            case 2:
              _this$accountDomainSe = this.accountDomainService.accountAggregate, vipInfo = _this$accountDomainSe.vipInfo, userInfo = _this$accountDomainSe.userInfo;
              this.accountApplicationOfflineService.updateUserInfo(Object.assign(Object.assign({}, userInfo), {
                vipUserInfo: vipInfo
              }));
              return _context2.abrupt("return", vipInfo);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    // 通过user_info接口更新绑定信息
  }, {
    key: "updateBindUserInfo",
    value: function updateBindUserInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$accountDomainSe2, userInfo, bindUserInfo, officialInfo;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.completionUserInfo();
            case 2:
              _this$accountDomainSe2 = this.accountDomainService.accountAggregate, userInfo = _this$accountDomainSe2.userInfo, bindUserInfo = _this$accountDomainSe2.bindUserInfo, officialInfo = _this$accountDomainSe2.officialInfo;
              this.accountApplicationOfflineService.updateUserInfo(Object.assign(Object.assign({}, userInfo), {
                bindUserInfo: bindUserInfo,
                officialInfo: officialInfo
              }));
              return _context3.abrupt("return", bindUserInfo);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
    // 通过user_info接口更新认证信息
  }, {
    key: "updateOfficialInfo",
    value: function updateOfficialInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$accountDomainSe3, userInfo, bindUserInfo, officialInfo;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.completionUserInfo();
            case 2:
              _this$accountDomainSe3 = this.accountDomainService.accountAggregate, userInfo = _this$accountDomainSe3.userInfo, bindUserInfo = _this$accountDomainSe3.bindUserInfo, officialInfo = _this$accountDomainSe3.officialInfo;
              this.accountApplicationOfflineService.updateUserInfo(Object.assign(Object.assign({}, userInfo), {
                bindUserInfo: bindUserInfo,
                officialInfo: officialInfo
              }));
              return _context4.abrupt("return", officialInfo);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
    // 通过user_info接口更新用户
  }, {
    key: "updateUserInfo",
    value: function updateUserInfo(userIndex) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var tinyId;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.accountDomainService.updatePersonalEnvAccountAggregate(userIndex);
            case 2:
              tinyId = this.accountDomainService.accountAggregate.userInfo.tinyId;
              this.loginDomainService.createLoginAggregate(tinyId);
              this.initDomainService();
              return _context5.abrupt("return", this.accountDomainService.accountAggregate.userInfo);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var flag;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.isInitFinish) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", true);
            case 2:
              _context6.next = 4;
              return this.initForUserInfoFetch();
            case 4:
              flag = _context6.sent;
              if (!flag) {
                _context6.next = 7;
                break;
              }
              return _context6.abrupt("return", true);
            case 7:
              return _context6.abrupt("return", this.initForUserInfoOfflineData());
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      // todo
      return;
    }
    // 更新用户头像和昵称
  }, {
    key: "updatePersonalNicknameAndAvatar",
    value: function updatePersonalNicknameAndAvatar(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.accountDomainService.updatePersonalNicknameAndAvatar(params));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
    // 获取登录密保问题
  }, {
    key: "getPasswordsModifyQuestionList",
    value: function getPasswordsModifyQuestionList() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var accountAggregate;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              accountAggregate = this.accountDomainService.accountAggregate;
              _context8.next = 3;
              return accountAggregate.passwordEntity.updatePwdQuestionList();
            case 3:
              return _context8.abrupt("return", accountAggregate.passwordEntity.pwdQuestionList);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
    // 获取账号列表 B + C(后续会废弃)
  }, {
    key: "getAccountProfileList",
    value: function getAccountProfileList(padID, folderID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var accountList;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.accountListApplicationService.getPersonalAccountList(padID, folderID);
            case 2:
              accountList = _context9.sent;
              return _context9.abrupt("return", translate$1(accountList));
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
    // 获取账号列表 C
  }, {
    key: "getFetchAccountList",
    value: function getFetchAccountList() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var accountList;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.accountListApplicationService.getFetchAccountList();
            case 2:
              accountList = _context10.sent;
              return _context10.abrupt("return", translate$1(accountList));
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
    // 请求user_info接口补充绑定信息和vip信息
  }, {
    key: "completionUserInfo",
    value: function completionUserInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var flag;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.accountDomainService.completionUserInfo();
            case 2:
              flag = _context11.sent;
              this.bindUserInfo = this.accountDomainService.accountAggregate.bindUserInfo;
              this.officialInfo = this.accountDomainService.accountAggregate.officialInfo;
              return _context11.abrupt("return", flag);
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getUserVipInfo",
    value: function getUserVipInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var flag;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.accountDomainService.getUserVipInfo();
            case 2:
              flag = _context12.sent;
              this.vipInfo = this.accountDomainService.accountAggregate.vipInfo;
              return _context12.abrupt("return", flag);
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
    }
    // 登录成功的跳转链接
  }, {
    key: "loginSuccessJumpUrl",
    value: function loginSuccessJumpUrl(successJumpUrl, isJumpEnterpriseHome, code, jumpOptions) {
      var handleJumpApplicationService = new HandleJumpApplicationService(this.accountDomainService);
      handleJumpApplicationService.loginSuccessJumpUrl(successJumpUrl, isJumpEnterpriseHome, code, jumpOptions);
    }
    // 退出登录的跳转链接
  }, {
    key: "logoutSuccessJumpUrl",
    value: function logoutSuccessJumpUrl() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var handleJumpApplicationService;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              handleJumpApplicationService = new HandleJumpApplicationService(this.accountDomainService);
              _context13.next = 3;
              return handleJumpApplicationService.logoutSuccessJumpUrl();
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
    // 登录
  }, {
    key: "login",
    value: function login(targetUrl, reLoginPC, loginWx) {
      var loginApplicationService = new LoginApplicationService(this.loginDomainService);
      loginApplicationService.login(targetUrl, reLoginPC, loginWx);
    }
    // 退出登录
  }, {
    key: "logout",
    value: function logout(u) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var logoutApplicationService;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              logoutApplicationService = new LogoutApplicationService(this.accountDomainService);
              return _context14.abrupt("return", logoutApplicationService.logout(u));
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
    // 删除账号
  }, {
    key: "deleteAccount",
    value: function deleteAccount(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", this.accountListApplicationService.deleteAccountForList(account));
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
    // 切换账号
  }, {
    key: "switchToAccount",
    value: function switchToAccount(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var switchAccountApplicationService;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              switchAccountApplicationService = new SwitchAccountApplicationService(this.accountDomainService, this.messageDomainService);
              _context16.next = 3;
              return switchAccountApplicationService.switchAccount(account);
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
    // 绑定账号
  }, {
    key: "bindQQAccount",
    value: function bindQQAccount(subscribe) {
      var bindApplication = new BindApplication(this.accountDomainService, this.loginDomainService);
      return bindApplication.qqBind(subscribe);
    }
    // 判断用户是否在可以进行认证的白名单里面
  }, {
    key: "getCertificationGrey",
    value: function getCertificationGrey() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _a, _b, _yield$this$accountDo, resData;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.accountDomainService.accountAggregate.accountRepository.getCertificationGrey();
            case 2:
              _yield$this$accountDo = _context17.sent;
              resData = _yield$this$accountDo.resData;
              return _context17.abrupt("return", ((_b = (_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.open) || false);
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "bindWeChatAccount",
    value: function bindWeChatAccount() {
      var bindApplication = new BindApplication(this.accountDomainService, this.loginDomainService);
      return bindApplication.wechatBind();
    }
  }, {
    key: "getQQBindingInfo",
    value: function getQQBindingInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", this.accountDomainService.accountAggregate.bindingQQInfo());
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    }
    /**
     * 获取是否可以显示商业化的提示信息，入参为对应的 type
     */
  }, {
    key: "getTipsStatus",
    value: function getTipsStatus(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var flag;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.accountDomainService.getTipsStatus(params);
            case 2:
              flag = _context19.sent;
              return _context19.abrupt("return", flag);
            case 4:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "initDomainAction",
    value: function initDomainAction() {
      // 透传部分 domain 的函数
      var accountAggregate = this.accountDomainService.accountAggregate;
      var passwordRepository = accountAggregate.passwordEntity.passwordRepository;
      this.sendVerifyCodeSMS = passwordRepository.pwdVerifyCodeGet.bind(passwordRepository);
      this.addPasswordsWithNewPhoneNumber = passwordRepository.pwdAdd.bind(passwordRepository);
      this.resetPasswords = passwordRepository.pwdReset.bind(passwordRepository);
      this.verifyCodeSMS = passwordRepository.pwdVerifyCodeCheck.bind(passwordRepository);
      this.verifyQuestionAnswers = passwordRepository.pwdQuestionCheck.bind(passwordRepository);
      this.delPasswords = passwordRepository.pwdDel.bind(passwordRepository);
      this.verifyPasswords = passwordRepository.pwdVerify.bind(passwordRepository);
      this.unbindAccount = accountAggregate.accountRepository.unbindUserInfo.bind(accountAggregate.accountRepository);
      this.getCurrentAccountBindingInfo = accountAggregate.currentLoginAccountBindInfo.bind(accountAggregate);
    }
  }, {
    key: "initDomainService",
    value: function initDomainService() {
      var accountAggregate = this.accountDomainService.accountAggregate;
      // 初始化 properties 属性
      this.userInfo = accountAggregate.userInfo;
      var _accountAggregate$pas = accountAggregate.passwordEntity,
        isHasPassword = _accountAggregate$pas.isHasPassword,
        phone = _accountAggregate$pas.phone;
      this.passwordsSettings = {
        enabled: isHasPassword,
        phoneNumber: phone
      };
      this.vipInfo = accountAggregate.vipInfo;
      this.bindUserInfo = accountAggregate.bindUserInfo;
      this.officialInfo = accountAggregate.officialInfo;
      this.accountApplicationOfflineService.addUserInfo(Object.assign(Object.assign({}, this.userInfo), {
        vipUserInfo: this.vipInfo,
        bindUserInfo: this.bindUserInfo
      }));
      // 初始化 domain 透传的方法
      this.initDomainAction();
    }
  }, {
    key: "initForUserInfoFetch",
    value: function initForUserInfoFetch() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var _yield$this$accountDo2, resData, error, userIndex, tinyId;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this.accountDomainService.userInfoRepository.getPersonalUserInfo();
            case 2:
              _yield$this$accountDo2 = _context20.sent;
              resData = _yield$this$accountDo2.resData;
              error = _yield$this$accountDo2.error;
              if (!error) {
                _context20.next = 7;
                break;
              }
              return _context20.abrupt("return", false);
            case 7:
              if ((resData === null || resData === void 0 ? void 0 : resData.cgicode) === 0 /* RETCODE.SUCCESS */) {
                userIndex = window.nowUserIndex || '';
                this.accountDomainService.createPersonalEnvAccountAggregateByUserInfoCgi(resData.data, userIndex);
                tinyId = this.accountDomainService.accountAggregate.userInfo.tinyId; // 创建登录领域
                this.loginDomainService.createLoginAggregate(tinyId);
                this.initDomainService();
              }
              return _context20.abrupt("return", true);
            case 9:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "initForUserInfoOfflineData",
    value: function initForUserInfoOfflineData() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var userInfoOfflineData;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return this.accountApplicationOfflineService.getUserInfo();
            case 2:
              userInfoOfflineData = _context21.sent;
              this.accountApplicationOfflineService.setOnOfflineState(true);
              if (userInfoOfflineData) {
                _context21.next = 6;
                break;
              }
              return _context21.abrupt("return", false);
            case 6:
              this.userInfo = userInfoOfflineData.userInfo;
              this.vipInfo = userInfoOfflineData.vipInfo;
              this.bindUserInfo = userInfoOfflineData.bindUserInfo;
              return _context21.abrupt("return", true);
            case 10:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
    }
  }]);
  return AccountApplicationService;
}(Disposable);
__decorate([SWRProperty, __metadata("design:type", Object)], AccountApplicationService.prototype, "userInfo", void 0);
__decorate([SWRProperty, __metadata("design:type", Object)], AccountApplicationService.prototype, "passwordsSettings", void 0);
__decorate([SWRProperty, __metadata("design:type", Object)], AccountApplicationService.prototype, "vipInfo", void 0);
__decorate([SWRProperty, __metadata("design:type", Object)], AccountApplicationService.prototype, "bindUserInfo", void 0);
__decorate([SWRProperty, __metadata("design:type", Object)], AccountApplicationService.prototype, "officialInfo", void 0);
__decorate([SWRFetcher('passwordsSettings'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], AccountApplicationService.prototype, "updatePasswordsSettings", null);
__decorate([SWRFetcher('vipInfo'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], AccountApplicationService.prototype, "updateVipInfo", null);
__decorate([SWRFetcher('bindUserInfo'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], AccountApplicationService.prototype, "updateBindUserInfo", null);
__decorate([SWRFetcher('officialInfo'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], AccountApplicationService.prototype, "updateOfficialInfo", null);
__decorate([SWRFetcher('userInfo'), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], AccountApplicationService.prototype, "updateUserInfo", null);
__decorate([lockOnce(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], AccountApplicationService.prototype, "init", null);
__decorate([releaseLock('init'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], AccountApplicationService.prototype, "dispose", null);
AccountApplicationService = __decorate([SWRProvider(), __param(0, IAccountDomainService), __param(1, ILoginDomainService), __param(2, IMessageDomainService), __metadata("design:paramtypes", [Object, Object, Object])], AccountApplicationService);

var EnterpriseAccountListApplicationService = /*#__PURE__*/function () {
  function EnterpriseAccountListApplicationService(messageDomainService, accountDomainService) {
    _classCallCheck(this, EnterpriseAccountListApplicationService);
    this.messageDomainService = messageDomainService;
    this.accountDomainService = accountDomainService;
  }
  _createClass(EnterpriseAccountListApplicationService, [{
    key: "getAccountList",
    value: function getAccountList() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getFetchEnterpriseAccountList();
            case 2:
              this.fetchEnterpriseAccountList = _context.sent;
              return _context.abrupt("return", this.fetchEnterpriseAccountList);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "deleteAccountForList",
    value: function deleteAccountForList(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var uid, isSuccessDeleteForEnterpriseAccountList, isAccountInEnterpriseAccountList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              uid = account.uid;
              isSuccessDeleteForEnterpriseAccountList = true;
              isAccountInEnterpriseAccountList = this.isHasSameUid(this.fetchEnterpriseAccountList, uid); // 删除B侧列表
              if (!isAccountInEnterpriseAccountList) {
                _context2.next = 7;
                break;
              }
              _context2.next = 6;
              return this.deleteFetchEnterpriseAccountList(account);
            case 6:
              isSuccessDeleteForEnterpriseAccountList = _context2.sent;
            case 7:
              return _context2.abrupt("return", this.changeDeleteAccountState(isSuccessDeleteForEnterpriseAccountList));
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
    * @deprecated 不再向localStorage 添加账号缓存 使用disklogin登录后后台会维护登录态
    **/
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  }, {
    key: "addAccountForList",
    value: function addAccountForList() {}
  }, {
    key: "dispose",
    value: function dispose() {
      this.messageDomainService.getPersonAccountListMessage.dispose();
    }
  }, {
    key: "deleteFetchEnterpriseAccountList",
    value: function deleteFetchEnterpriseAccountList(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _account$cookie, wedocSid, wedriveSid, weSid;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _account$cookie = account.cookie, wedocSid = _account$cookie.wedocSid, wedriveSid = _account$cookie.wedriveSid;
              weSid = wedocSid || wedriveSid;
              if (weSid) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return", false);
            case 4:
              _context3.next = 6;
              return this.accountDomainService.accountAggregate.enterpriseAccountListEntity.delEnterpriseAccountForList(weSid);
            case 6:
              return _context3.abrupt("return", _context3.sent);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getFetchEnterpriseAccountList",
    value: function getFetchEnterpriseAccountList() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.accountDomainService.accountAggregate.enterpriseAccountListEntity.getEnterpiseAccountList();
            case 2:
              return _context4.abrupt("return", _context4.sent);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "changeDeleteAccountState",
    value: function changeDeleteAccountState(isSuccessDeleteForEnterpriseAccountList) {
      if (isSuccessDeleteForEnterpriseAccountList) {
        return DELETE_ACCOUNT_FOR_LIST_STATE.SUCCESS;
      }
      return DELETE_ACCOUNT_FOR_LIST_STATE.FAIL;
    }
  }, {
    key: "isHasSameUid",
    value: function isHasSameUid(accountList, uid) {
      // 不同登录态下uid代表的id 不同，c端登录态下uid为tinyid b端openid登录态下uid为微盘id b端vid登录态下uid为vid
      return accountList.some(function (item) {
        if (item.uid === uid) {
          return true;
        }
        return false;
      });
    }
  }]);
  return EnterpriseAccountListApplicationService;
}();
EnterpriseAccountListApplicationService = __decorate([__param(0, IMessageDomainService), __param(1, IEnterpriseAccountDomainService), __metadata("design:paramtypes", [Object, Object])], EnterpriseAccountListApplicationService);

var HandleEnterpriseJumpApplicationService = /*#__PURE__*/function () {
  function HandleEnterpriseJumpApplicationService() {
    _classCallCheck(this, HandleEnterpriseJumpApplicationService);
  }
  _createClass(HandleEnterpriseJumpApplicationService, [{
    key: "loginSuccessJumpUrl",
    value: function loginSuccessJumpUrl(successJumpUrl, _checkKey) {
      tencentDocOpenUrlForAll({
        replace: true,
        url: successJumpUrl,
        noUserIndex: true
      });
    }
  }, {
    key: "logoutSuccessJumpUrl",
    value: function logoutSuccessJumpUrl() {
      var removeUserIndexUrl = removeURLParameters(window.location.href, 'u', 'wwapp_deviceid', 'wwapp_vid', 'wwapp_cst', 'needShowTips');
      if (window.location.pathname.includes('home/recent')) {
        window.location.replace("".concat(C_LOGIN_URL, "?success_jump_url=").concat(encodeURIComponent(TOC_HOME_PAGE)));
        return;
      }
      window.location.replace(removeUserIndexUrl);
    }
  }]);
  return HandleEnterpriseJumpApplicationService;
}();

var EnterpriseLogoutApplicationService = /*#__PURE__*/function () {
  function EnterpriseLogoutApplicationService(accountDomainService) {
    _classCallCheck(this, EnterpriseLogoutApplicationService);
    this.accountDomainService = accountDomainService;
  }
  _createClass(EnterpriseLogoutApplicationService, [{
    key: "logout",
    value: function logout() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$accountDomainSe, loginType, tinyId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$accountDomainSe = this.accountDomainService.accountAggregate.userInfo, loginType = _this$accountDomainSe.loginType, tinyId = _this$accountDomainSe.tinyId;
              if (!(loginType === ACCOUNT_TYPE.WORK)) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return this.logoutForEnterpriseAccount();
            case 4:
              clearAllCookie();
              MsgCenter.postMessage({
                type: ILogoutMessageType.LOGOUT,
                data: tinyId,
                needCookie: true
              });
              return _context.abrupt("return", true);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "logoutForEnterpriseAccount",
    value: function logoutForEnterpriseAccount() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var wedocSid, wedriveSid, weSid, _yield$this$accountDo, resData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              wedocSid = getCookie('wedoc_sid');
              wedriveSid = getCookie('wedrive_sid');
              weSid = wedocSid || wedriveSid;
              if (!weSid) {
                _context2.next = 10;
                break;
              }
              _context2.next = 6;
              return this.accountDomainService.accountAggregate.accountRepository.wecomLogoutForBDomain(weSid);
            case 6:
              _yield$this$accountDo = _context2.sent;
              resData = _yield$this$accountDo.resData;
              if (!((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */)) {
                _context2.next = 10;
                break;
              }
              return _context2.abrupt("return", true);
            case 10:
              return _context2.abrupt("return", false);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }]);
  return EnterpriseLogoutApplicationService;
}();
EnterpriseLogoutApplicationService = __decorate([__param(0, IEnterpriseAccountDomainService), __metadata("design:paramtypes", [Object])], EnterpriseLogoutApplicationService);

var EnterpriseSwitchAccountApplication = /*#__PURE__*/function () {
  function EnterpriseSwitchAccountApplication(messageDomainService) {
    _classCallCheck(this, EnterpriseSwitchAccountApplication);
    this.messageDomainService = messageDomainService;
  }
  _createClass(EnterpriseSwitchAccountApplication, [{
    key: "switchAccount",
    value: function switchAccount(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cookie, uid, result, redirectUri, newUrl;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cookie = account.cookie, uid = account.uid;
              if (!(account.fromDomain === FromDomin.C_DOMAIN)) {
                _context.next = 9;
                break;
              }
              if (cookie) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", false);
            case 4:
              _context.next = 6;
              return this.switchPersonAccount(cookie);
            case 6:
              result = _context.sent;
              if (result) {
                redirectUri = this.isInDesktopPage() ? TOC_HOME_PAGE : "".concat(location.origin).concat(location.pathname);
                newUrl = "".concat(C_JUMP_TO_B_URL, "?redirect_uri=").concat(redirectUri, "u=").concat(account.userIndex);
                window.location.href = newUrl;
              }
              return _context.abrupt("return", result);
            case 9:
              this.switchEnterpriseAccount(account);
              MsgCenter.postMessage({
                type: ILogoutMessageType.SWITCH,
                data: uid,
                needCookie: true
              });
              return _context.abrupt("return", true);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "switchPersonAccount",
    value: function switchPersonAccount(cookie) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.messageDomainService.switchPersonAccountMessage.connect();
              this.getIframeMountMessage(cookie);
              this.messageDomainService.switchPersonAccountMessage.createSwitchEnterpriseAccount(function () {
                _this.messageDomainService.switchPersonAccountMessage.sendSwitchAccountMessage(cookie);
              });
              _context2.next = 5;
              return this.getSwitchAccountMessage();
            case 5:
              return _context2.abrupt("return", _context2.sent);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "switchEnterpriseAccount",
    value: function switchEnterpriseAccount(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _a, _b, _c, _d, wedocSid, tdocUid, wedocOpenid, wedriveSid;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              wedocSid = (_a = account.cookie) === null || _a === void 0 ? void 0 : _a.wedocSid;
              tdocUid = (_b = account.cookie) === null || _b === void 0 ? void 0 : _b.tdocUid;
              wedocOpenid = (_c = account.cookie) === null || _c === void 0 ? void 0 : _c.wedocOpenid;
              wedriveSid = (_d = account.cookie) === null || _d === void 0 ? void 0 : _d.wedriveSid;
              if (wedocSid) {
                setCookie('wedoc_sid', wedocSid, 30, '/', TOB_COOKIE_DOMAIN);
                tdocUid && setCookie('tdoc_uid', tdocUid, 30, '/', TOB_COOKIE_DOMAIN);
                wedocOpenid && setCookie('wedoc_openid', wedocOpenid, 30, '/', TOB_COOKIE_DOMAIN);
              } else {
                wedriveSid && setCookie('wedrive_sid', wedriveSid, 30, '/', PARENT_TOB_COOKIE_DOMAIN);
              }
              location.reload();
              return _context3.abrupt("return", true);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
    }
  }, {
    key: "getIframeMountMessage",
    value: function getIframeMountMessage(cookie) {
      var _this2 = this;
      return new Promise(function (resolve) {
        _this2.messageDomainService.switchPersonAccountMessage.getIframeMountMessage(function () {
          resolve(true);
          _this2.messageDomainService.switchPersonAccountMessage.sendSwitchAccountMessage(cookie);
        });
      });
    }
  }, {
    key: "getSwitchAccountMessage",
    value: function getSwitchAccountMessage() {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.messageDomainService.switchPersonAccountMessage.getSwitchAccountMessage(function (message) {
          var data = message.data;
          if (data.event === 'SUCCESS_SET_COOKIE') {
            resolve(true);
          }
          resolve(false);
        });
      });
    }
  }, {
    key: "isInDesktopPage",
    value: function isInDesktopPage() {
      return document.location.pathname.indexOf('/home/') > -1;
    }
  }]);
  return EnterpriseSwitchAccountApplication;
}();
EnterpriseSwitchAccountApplication = __decorate([__param(0, IMessageDomainService), __metadata("design:paramtypes", [Object])], EnterpriseSwitchAccountApplication);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var translate = createTranslator(dict);
var EnterpriseAccountApplicationService = /*#__PURE__*/function (_Disposable) {
  _inherits(EnterpriseAccountApplicationService, _Disposable);
  var _super = _createSuper(EnterpriseAccountApplicationService);
  function EnterpriseAccountApplicationService(accountDomainService, loginDomainService, messageDomainService) {
    var _this;
    _classCallCheck(this, EnterpriseAccountApplicationService);
    var _a;
    _this = _super.call(this);
    _this.accountDomainService = accountDomainService;
    _this.loginDomainService = loginDomainService;
    _this.messageDomainService = messageDomainService;
    _this.accountApplicationOfflineService = new AccountApplicationOfflineService();
    _this.enterpriseAccountListApplicationService = new EnterpriseAccountListApplicationService(messageDomainService, accountDomainService);
    _this.dcLoginApplicationService = new DCLoginApplicationService(loginDomainService, messageDomainService, accountDomainService);
    var basicClientVars = globalThis === null || globalThis === void 0 ? void 0 : globalThis.basicClientVars;
    _this.loginDomainService.createLoginAggregate(((_a = basicClientVars === null || basicClientVars === void 0 ? void 0 : basicClientVars.userInfo) === null || _a === void 0 ? void 0 : _a.tinyId) || NOT_LOGIN_TINYID);
    _this.createEnterpriseEnvAccountAggregateByBasicClientVarsAndDocInfo();
    return _this;
  }
  // 通过user_info接口更新vip信息
  _createClass(EnterpriseAccountApplicationService, [{
    key: "updateVipInfo",
    value: function updateVipInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$accountDomainSe, vipInfo, userInfo, bindUserInfo, officialInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.completionUserInfo();
            case 2:
              _this$accountDomainSe = this.accountDomainService.accountAggregate, vipInfo = _this$accountDomainSe.vipInfo, userInfo = _this$accountDomainSe.userInfo, bindUserInfo = _this$accountDomainSe.bindUserInfo, officialInfo = _this$accountDomainSe.officialInfo;
              this.accountApplicationOfflineService.updateUserInfo(Object.assign(Object.assign({}, userInfo), {
                vipUserInfo: vipInfo,
                bindUserInfo: bindUserInfo,
                officialInfo: officialInfo
              }));
              return _context.abrupt("return", vipInfo);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "updateUserInfo",
    value: function updateUserInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var userInfoData, _yield$this$accountDo, docInfoData, tinyId, accountAggregate;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.accountDomainService.userInfoRepository.getEnterpriseUserInfo();
            case 2:
              userInfoData = _context2.sent;
              _context2.next = 5;
              return this.accountDomainService.userInfoRepository.getEnterpriseDocInfo();
            case 5:
              _yield$this$accountDo = _context2.sent;
              docInfoData = _yield$this$accountDo.resData;
              if (!(userInfoData && (docInfoData === null || docInfoData === void 0 ? void 0 : docInfoData.cgicode) === 0 /* RETCODE.SUCCESS */)) {
                _context2.next = 12;
                break;
              }
              tinyId = this.accountDomainService.accountAggregate.userInfo.tinyId;
              this.loginDomainService.createLoginAggregate(tinyId);
              accountAggregate = this.accountDomainService.accountAggregate;
              return _context2.abrupt("return", accountAggregate.userInfo);
            case 12:
              this.accountApplicationOfflineService.updateUserInfo(Object.assign({}, this.userInfo));
              return _context2.abrupt("return", this.userInfo);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var flag;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.initForUserInfoFetch();
            case 2:
              flag = _context3.sent;
              if (!flag) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return", true);
            case 5:
              return _context3.abrupt("return", this.initForUserInfoOfflineData());
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      // todo
      return;
    }
    // 获取账号列表
  }, {
    key: "getAccountProfileList",
    value: function getAccountProfileList() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var accountList;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.enterpriseAccountListApplicationService.getAccountList();
            case 2:
              accountList = _context4.sent;
              return _context4.abrupt("return", translate(accountList));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
    // 删除账号
  }, {
    key: "deleteAccount",
    value: function deleteAccount(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.enterpriseAccountListApplicationService.deleteAccountForList(account));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
    // 添加账号
    /**
     * @deprecated 不再向localStorage 添加账号缓存 使用disklogin登录后后台会维护登录态
     **/
  }, {
    key: "addAccount",
    value: function addAccount() {}
    // 切换账号
  }, {
    key: "switchToAccount",
    value: function switchToAccount(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var switchAccountApplicationService;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              switchAccountApplicationService = new EnterpriseSwitchAccountApplication(this.messageDomainService);
              _context6.next = 3;
              return switchAccountApplicationService.switchAccount(account);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
    // 请求user_info接口补充绑定信息和vip信息
  }, {
    key: "completionUserInfo",
    value: function completionUserInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var flag;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.accountDomainService.completionUserInfo();
            case 2:
              flag = _context7.sent;
              this.vipInfo = this.accountDomainService.accountAggregate.vipInfo;
              return _context7.abrupt("return", flag);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
    // 登录成功的跳转链接
  }, {
    key: "loginSuccessJumpUrl",
    value: function loginSuccessJumpUrl(successJumpUrl, checkKey) {
      // 多 Tab 多账号身份方案降级单账号灰度开关
      var nowUserIndex = this.accountDomainService.accountAggregate.userInfo.nowUserIndex;
      // 登录推送信息到其他 tab
      MsgCenter.postMessage({
        type: ILogoutMessageType.LOGIN,
        data: nowUserIndex,
        needCookie: true
      });
      var handleJumpApplicationService = new HandleEnterpriseJumpApplicationService();
      handleJumpApplicationService.loginSuccessJumpUrl(successJumpUrl, checkKey);
    }
    // 退出登录的跳转链接
  }, {
    key: "logoutSuccessJumpUrl",
    value: function logoutSuccessJumpUrl() {
      var handleJumpApplicationService = new HandleEnterpriseJumpApplicationService();
      handleJumpApplicationService.logoutSuccessJumpUrl();
    }
    // 登录
  }, {
    key: "login",
    value: function login(targetUrl, reLoginPC, loginWx) {
      var loginApplicationService = new LoginApplicationService(this.loginDomainService);
      loginApplicationService.login(targetUrl, reLoginPC, loginWx);
    }
    // 退出登录
  }, {
    key: "logout",
    value: function logout() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var logoutApplicationService;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              logoutApplicationService = new EnterpriseLogoutApplicationService(this.accountDomainService);
              return _context8.abrupt("return", logoutApplicationService.logout());
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "initForUserInfoFetch",
    value: function initForUserInfoFetch() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", Promise.all([this.accountDomainService.userInfoRepository.getEnterpriseUserInfo()]).then(function (responses) {
                // 接口获取userinfo
                var _responses = _slicedToArray(responses, 1),
                  userInfoData = _responses[0];
                if (userInfoData) {
                  _this2.accountDomainService.createEnterpriseEnvAccountAggregateByUserInfoCgi(userInfoData);
                  var tinyId = _this2.accountDomainService.accountAggregate.userInfo.tinyId;
                  // 创建登录领域
                  _this2.loginDomainService.createLoginAggregate(tinyId);
                  var accountAggregate = _this2.accountDomainService.accountAggregate;
                  _this2.userInfo = accountAggregate.userInfo;
                  _this2.accountApplicationOfflineService.addUserInfo(Object.assign({}, _this2.userInfo));
                }
                return true;
              }));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "initForUserInfoOfflineData",
    value: function initForUserInfoOfflineData() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var userInfoOfflineData;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.accountApplicationOfflineService.getUserInfo();
            case 2:
              userInfoOfflineData = _context10.sent;
              this.accountApplicationOfflineService.setOnOfflineState(true);
              if (userInfoOfflineData) {
                _context10.next = 6;
                break;
              }
              return _context10.abrupt("return", false);
            case 6:
              this.userInfo = userInfoOfflineData.userInfo;
              return _context10.abrupt("return", true);
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "createEnterpriseEnvAccountAggregateByBasicClientVarsAndDocInfo",
    value: function createEnterpriseEnvAccountAggregateByBasicClientVarsAndDocInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var basicClientVars, success, accountAggregate;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              basicClientVars = globalThis === null || globalThis === void 0 ? void 0 : globalThis.basicClientVars;
              success = this.accountDomainService.createEnterpriseEnvAccountAggregateByBasicClientVars(basicClientVars === null || basicClientVars === void 0 ? void 0 : basicClientVars.userInfo);
              accountAggregate = this.accountDomainService.accountAggregate;
              this.userInfo = accountAggregate.userInfo;
              return _context11.abrupt("return", success);
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }]);
  return EnterpriseAccountApplicationService;
}(Disposable);
__decorate([SWRProperty, __metadata("design:type", Object)], EnterpriseAccountApplicationService.prototype, "userInfo", void 0);
__decorate([SWRProperty, __metadata("design:type", Object)], EnterpriseAccountApplicationService.prototype, "vipInfo", void 0);
__decorate([SWRFetcher('vipInfo'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], EnterpriseAccountApplicationService.prototype, "updateVipInfo", null);
__decorate([SWRFetcher('userInfo'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], EnterpriseAccountApplicationService.prototype, "updateUserInfo", null);
__decorate([lockOnce(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], EnterpriseAccountApplicationService.prototype, "init", null);
__decorate([releaseLock('init'), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], EnterpriseAccountApplicationService.prototype, "dispose", null);
EnterpriseAccountApplicationService = __decorate([SWRProvider(), __param(0, IEnterpriseAccountDomainService), __param(1, ILoginDomainService), __param(2, IMessageDomainService), __metadata("design:paramtypes", [Object, Object, Object])], EnterpriseAccountApplicationService);

var IAccountApplicationService = createDecorator('IAccountApplicationService');

var IEnterpriseAccountApplicationService = createDecorator('IEnterpriseAccountApplicationService');

var QRCodeStatus;
(function (QRCodeStatus) {
  // 二维码已就绪且可用
  QRCodeStatus["CODE_IS_READY"] = "CODE_IS_READY";
  // 用户已扫码但尚未登录
  QRCodeStatus["USER_HAS_SCANNED"] = "USER_HAS_SCANNED";
  // 二维码已过期
  QRCodeStatus["CODE_WAS_EXPIRED"] = "CODE_WAS_EXPIRED";
  // 用户已点击确认授权
  QRCodeStatus["USER_HAS_CONFIRMED"] = "USER_HAS_CONFIRMED";
  // 发生了异常
  QRCodeStatus["ERROR"] = "ERROR";
})(QRCodeStatus || (QRCodeStatus = {}));

var TenantType;
(function (TenantType) {
  TenantType["TENCENT_DOCS"] = "TENCENT_DOCS";
})(TenantType || (TenantType = {}));

var IBindWechatState;
(function (IBindWechatState) {
  IBindWechatState["CODE_IS_READY"] = "CODE_IS_READY";
  IBindWechatState["BIND_POLLING_RUNNING"] = "BIND_POLLING_RUNNING";
  IBindWechatState["BIND_POLLING_FINISH"] = "BIND_POLLING_FINISH";
  IBindWechatState["BIND_TIMEOUT"] = "BIND_TIMEOUT";
  IBindWechatState["CODE_WAS_EXPIRED"] = "CODE_WAS_EXPIRED";
  IBindWechatState["ERROR"] = "ERROR";
})(IBindWechatState || (IBindWechatState = {}));

var CREATE_DOC_NEW = '/cgi-bin/online-docs/createdoc_new';
var CreateDocRequest = /*#__PURE__*/function () {
  function CreateDocRequest(options) {
    _classCallCheck(this, CreateDocRequest);
    var _a, _b, _c;
    this.title = options.title;
    this.padId = options.padId;
    this.domainId = options.domainId;
    this.docType = options.docType;
    this.create_type = (_a = options.create_type) !== null && _a !== void 0 ? _a : '';
    this.redirect = (_b = options.redirect) !== null && _b !== void 0 ? _b : '';
    this.isMiniProgram = (_c = options.isMiniProgram) !== null && _c !== void 0 ? _c : '';
  }
  /**
   * 直接生成副本的接口
   */
  _createClass(CreateDocRequest, [{
    key: "send",
    value: function send() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var formData, _yield$networkRequest, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              formData = new FormData();
              formData.append('domain_id', this.domainId);
              formData.append('title', this.title);
              formData.append('pad_id', this.padId);
              formData.append('xsrf', getXsrfToken());
              formData.append('create_type', this.create_type);
              formData.append('redirect', this.redirect);
              formData.append('isMiniProgram', this.isMiniProgram);
              _context.next = 10;
              return networkRequest.post(CREATE_DOC_NEW, formData);
            case 10:
              _yield$networkRequest = _context.sent;
              data = _yield$networkRequest.data;
              return _context.abrupt("return", data);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return CreateDocRequest;
}();

var COPT_DRIVE_FILE = '/v2/file/clone';
var DriveRequest = /*#__PURE__*/function () {
  function DriveRequest(options) {
    _classCallCheck(this, DriveRequest);
    this.file_id = options.file_id;
    this.parent_id = options.parent_id;
  }
  /**
   * 本地文件生成副本，比如drive
   */
  _createClass(DriveRequest, [{
    key: "send",
    value: function send() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$networkRequest, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return networkRequest.post("".concat(COPT_DRIVE_FILE, "?xsrf=").concat(getXsrfToken()), {
                file_id: this.file_id,
                parent_id: this.parent_id
              });
            case 2:
              _yield$networkRequest = _context.sent;
              data = _yield$networkRequest.data;
              return _context.abrupt("return", data);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }]);
  return DriveRequest;
}();

var COPY_DOC_ASYNC_API = '/cgi-bin/online_docs/copydoc_async';
var COPY_DOC_LOOP_API = '/cgi-bin/online_docs/copydoc_loop';
var InCloningProcess = 10027;
var cloneFileError = {
  retcode: -1,
  doc_url: '',
  message: '创建副本存到本地失败',
  doc_id: {
    pad_id: ''
  }
};
var LoopRequest = /*#__PURE__*/function () {
  function LoopRequest(options) {
    _classCallCheck(this, LoopRequest);
    this.logger = new Logger('IDocsManagementService').use('console');
    this.title = options.title;
    this.padId = options.padId;
    this.domainId = options.domainId;
  }
  /**
   * 这里调用需要轮询的生成副本接口
   */
  _createClass(LoopRequest, [{
    key: "send",
    value: function send() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var formData, res, data, retcode, pad_id;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              formData = new FormData();
              formData.append('domain_id', this.domainId);
              formData.append('title', this.title);
              formData.append('pad_id', this.padId);
              formData.append('xsrf', getXsrfToken());
              _context.next = 7;
              return networkRequest.post(COPY_DOC_ASYNC_API, formData);
            case 7:
              res = _context.sent;
              data = res.data;
              retcode = data.retcode, pad_id = data.doc_id.pad_id; // 这里有可能出现，drive 空间不足, 无法生成副本, 提前返回，让品类弹窗
              if (!(retcode !== 0 || !pad_id)) {
                _context.next = 13;
                break;
              }
              this.logger.error(data);
              return _context.abrupt("return", data);
            case 13:
              _context.next = 15;
              return this.requestCreateCopyLoop(data);
            case 15:
              return _context.abrupt("return", _context.sent);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "requestCreateCopyLoop",
    value: function requestCreateCopyLoop(docInfo) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var pad_id, doc_url, tryCount, formData, res, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              pad_id = docInfo.doc_id.pad_id; // 这里企微 tob，不会在这个接口里面返回 doc_url，要在下面 loop 的接口里面去获取
              doc_url = docInfo.doc_url;
              tryCount = 30;
            case 3:
              if (!(tryCount = tryCount - 1)) {
                _context2.next = 20;
                break;
              }
              _context2.next = 6;
              return sleep(2000);
            case 6:
              formData = new FormData();
              formData.append('domain_id', this.domainId);
              formData.append('pad_id', pad_id);
              formData.append('xsrf', getXsrfToken());
              _context2.next = 12;
              return networkRequest.post(COPY_DOC_LOOP_API, formData);
            case 12:
              res = _context2.sent;
              data = res.data; // 这里企微 tob，要在 loop 的接口里面去获取
              doc_url = doc_url || data.doc_url;
              /**
               * 如果 retcode 是 10027，说明文档还在复制中，一定间隔后继续轮询
               * 如果 retcode 是其他错误，直接报错
               * 如果 retcode 为 0，说明复制成功，可以跳转。
               */
              if (!(data.retcode === InCloningProcess)) {
                _context2.next = 17;
                break;
              }
              return _context2.abrupt("continue", 3);
            case 17:
              return _context2.abrupt("return", data);
            case 20:
              return _context2.abrupt("return", cloneFileError);
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }]);
  return LoopRequest;
}();

var IDocsManagementService = createDecorator('IDocsManagementService');
var DocsManagementService = /*#__PURE__*/function () {
  function DocsManagementService() {
    _classCallCheck(this, DocsManagementService);
  }
  _createClass(DocsManagementService, [{
    key: "loopClone",
    value:
    /**
     * 生成副本逻辑
     * loopClone: 需要轮询 => 为大文档定制，目前不支持3.0文档
     * createDocClone: 通用接口 => 缺点是超时没有保证，适合小文档
     * driveClone: 文件为本地文件，比如drive
     */
    function loopClone(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new LoopRequest(options.params).send();
            case 2:
              data = _context.sent;
              this.handleResult(options, data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "createDocClone",
    value: function createDocClone(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return new CreateDocRequest(options.params).send();
            case 2:
              data = _context2.sent;
              this.handleResult(options, data);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "driveClone",
    value: function driveClone(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return new DriveRequest(options.params).send();
            case 2:
              data = _context3.sent;
              this.handleResult(options, data);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "handleResult",
    value: function handleResult(options, data) {
      if (data) {
        options.success(data);
      } else {
        options.fail();
      }
    }
  }]);
  return DocsManagementService;
}();

export { AccountApplicationService, ConnectionControllerService, ConnectionShowTips, DELETE_ACCOUNT_FOR_LIST_STATE, DocsManagementService, EnterpriseAccountApplicationService, IAccountApplicationService, IBindQQStatus, IBindWechatState, IConnectionControllerService, IDocsManagementService, IEnterpriseAccountApplicationService, IPermissionLevel, IQrWechatLoginStatus, IQrWecomLoginStatus, IWechatLoginCase, LoginType, QRCodeStatus, QrQQLoginStatus, SHUTDOWN_CODE, TenantType, gotoFeedback };
//# sourceMappingURL=index.js.map
